/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface AccountAdminResponseDTO {
    /**
     * The ID of the account (if existing)
     */
    'accountId': number;
    /**
     * The artist
     */
    'artist'?: ArtistResponseDTOMin;
    /**
     * The likes amount
     */
    'likesAmount': number;
    /**
     * The downloads amount
     */
    'downloadsAmount': number;
    /**
     * The pieces amount
     */
    'piecesAmount': number;
    /**
     * The date when the no user joined
     */
    'joined': string;
    /**
     * The date when the artist profile was the last time updated
     */
    'lastUpdated'?: string;
    /**
     * The date when the artist profile was the last time updated
     */
    'lastSeen': string;
    /**
     * The avg piece score
     */
    'avgPieceScore': number;
    /**
     * The users account balance
     */
    'balance': number;
    /**
     * The users email
     */
    'email': string;
    /**
     * If the user is blocked
     */
    'blocked': boolean;
    /**
     * If the user is activated
     */
    'activated': boolean;
    /**
     * If the user is verified
     */
    'verified': boolean;
    /**
     * The users name
     */
    'name': string;
}
export interface AccountAdminResponseDTOMin {
    /**
     * The ID of the account (if existing)
     */
    'accountId': number;
    /**
     * The users email
     */
    'email': string;
}
export interface AccountConfirmedDto {
    'confirmed'?: boolean;
    'account'?: number;
}
export interface AccountCreditCheckoutResponse {
    /**
     * The stripe checkout response dto
     */
    'stripeCheckout': StripeCheckoutResponseDTO;
    /**
     * The amount that has been uploaded
     */
    'amount': number;
}
export interface AccountEmailDto {
    'email'?: string;
    'id'?: number;
}
export interface AllPayoutsResponseDTO {
    /**
     * List of open payout requests
     */
    'open': Array<PayoutResponseDTO>;
    /**
     * List of closed payout requests
     */
    'closed': Array<PayoutResponseDTO>;
}
export interface ArtistAdminResponseDTO {
    /**
     * The ID of the account (if existing)
     */
    'accountId'?: number;
    /**
     * The artist
     */
    'artist': ArtistResponseDTOMin;
    /**
     * The likes amount
     */
    'likesAmount': number;
    /**
     * The downloads amount
     */
    'downloadsAmount': number;
    /**
     * The pieces amount
     */
    'piecesAmount': number;
    /**
     * The date when the no user joined
     */
    'joined': string;
    /**
     * The date when the artist profile was the last time updated
     */
    'lastUpdated': string;
    /**
     * The avg piece score
     */
    'avgPieceScore': number;
}
export interface ArtistDTO {
    /**
     * First Name of the artist
     */
    'firstName': string;
    /**
     * Last Name of the artist
     */
    'lastName'?: string;
    /**
     * short biography of the artist
     */
    'shortBiography'?: string;
    /**
     * biography of the artist
     */
    'biography'?: string;
    /**
     * social media links of the artist
     */
    'socialMedia'?: { [key: string]: string; };
    /**
     * country of the artist
     */
    'country'?: ArtistDTOCountryEnum;
}

export const ArtistDTOCountryEnum = {
    NoSelection: 'NO_SELECTION',
    Afghanistan: 'AFGHANISTAN',
    Albania: 'ALBANIA',
    Algeria: 'ALGERIA',
    Andorra: 'ANDORRA',
    Angola: 'ANGOLA',
    AntiguaAndBarbuda: 'ANTIGUA_AND_BARBUDA',
    Argentina: 'ARGENTINA',
    Armenia: 'ARMENIA',
    Australia: 'AUSTRALIA',
    Austria: 'AUSTRIA',
    Azerbaijan: 'AZERBAIJAN',
    Bahamas: 'BAHAMAS',
    Bahrain: 'BAHRAIN',
    Bangladesh: 'BANGLADESH',
    Barbados: 'BARBADOS',
    Belarus: 'BELARUS',
    Belgium: 'BELGIUM',
    Belize: 'BELIZE',
    Benin: 'BENIN',
    Bhutan: 'BHUTAN',
    Bolivia: 'BOLIVIA',
    BosniaAndHerzegovina: 'BOSNIA_AND_HERZEGOVINA',
    Botswana: 'BOTSWANA',
    Brazil: 'BRAZIL',
    Brunei: 'BRUNEI',
    Bulgaria: 'BULGARIA',
    BurkinaFaso: 'BURKINA_FASO',
    Burundi: 'BURUNDI',
    CaboVerde: 'CABO_VERDE',
    Cambodia: 'CAMBODIA',
    Cameroon: 'CAMEROON',
    Canada: 'CANADA',
    CentralAfricanRepublic: 'CENTRAL_AFRICAN_REPUBLIC',
    Chad: 'CHAD',
    Chile: 'CHILE',
    China: 'CHINA',
    Colombia: 'COLOMBIA',
    Comoros: 'COMOROS',
    CongoBrazzaville: 'CONGO_BRAZZAVILLE',
    CongoKinshasa: 'CONGO_KINSHASA',
    CostaRica: 'COSTA_RICA',
    Croatia: 'CROATIA',
    Cuba: 'CUBA',
    Cyprus: 'CYPRUS',
    CzechRepublic: 'CZECH_REPUBLIC',
    Denmark: 'DENMARK',
    Djibouti: 'DJIBOUTI',
    Dominica: 'DOMINICA',
    DominicanRepublic: 'DOMINICAN_REPUBLIC',
    Ecuador: 'ECUADOR',
    Egypt: 'EGYPT',
    ElSalvador: 'EL_SALVADOR',
    EquatorialGuinea: 'EQUATORIAL_GUINEA',
    Eritrea: 'ERITREA',
    Estonia: 'ESTONIA',
    Eswatini: 'ESWATINI',
    Ethiopia: 'ETHIOPIA',
    Fiji: 'FIJI',
    Finland: 'FINLAND',
    France: 'FRANCE',
    Gabon: 'GABON',
    Gambia: 'GAMBIA',
    Georgia: 'GEORGIA',
    Germany: 'GERMANY',
    Ghana: 'GHANA',
    Greece: 'GREECE',
    Grenada: 'GRENADA',
    Guatemala: 'GUATEMALA',
    Guinea: 'GUINEA',
    GuineaBissau: 'GUINEA_BISSAU',
    Guyana: 'GUYANA',
    Haiti: 'HAITI',
    Honduras: 'HONDURAS',
    Hungary: 'HUNGARY',
    Iceland: 'ICELAND',
    India: 'INDIA',
    Indonesia: 'INDONESIA',
    Iran: 'IRAN',
    Iraq: 'IRAQ',
    Ireland: 'IRELAND',
    Israel: 'ISRAEL',
    Italy: 'ITALY',
    IvoryCoast: 'IVORY_COAST',
    Jamaica: 'JAMAICA',
    Japan: 'JAPAN',
    Jordan: 'JORDAN',
    Kazakhstan: 'KAZAKHSTAN',
    Kenya: 'KENYA',
    Kiribati: 'KIRIBATI',
    Kosovo: 'KOSOVO',
    Kuwait: 'KUWAIT',
    Kyrgyzstan: 'KYRGYZSTAN',
    Laos: 'LAOS',
    Latvia: 'LATVIA',
    Lebanon: 'LEBANON',
    Lesotho: 'LESOTHO',
    Liberia: 'LIBERIA',
    Libya: 'LIBYA',
    Liechtenstein: 'LIECHTENSTEIN',
    Lithuania: 'LITHUANIA',
    Luxembourg: 'LUXEMBOURG',
    Madagascar: 'MADAGASCAR',
    Malawi: 'MALAWI',
    Malaysia: 'MALAYSIA',
    Maldives: 'MALDIVES',
    Mali: 'MALI',
    Malta: 'MALTA',
    MarshallIslands: 'MARSHALL_ISLANDS',
    Mauritania: 'MAURITANIA',
    Mauritius: 'MAURITIUS',
    Mexico: 'MEXICO',
    Micronesia: 'MICRONESIA',
    Moldova: 'MOLDOVA',
    Monaco: 'MONACO',
    Mongolia: 'MONGOLIA',
    Montenegro: 'MONTENEGRO',
    Morocco: 'MOROCCO',
    Mozambique: 'MOZAMBIQUE',
    Myanmar: 'MYANMAR',
    Namibia: 'NAMIBIA',
    Nauru: 'NAURU',
    Nepal: 'NEPAL',
    Netherlands: 'NETHERLANDS',
    NewZealand: 'NEW_ZEALAND',
    Nicaragua: 'NICARAGUA',
    Niger: 'NIGER',
    Nigeria: 'NIGERIA',
    NorthKorea: 'NORTH_KOREA',
    NorthMacedonia: 'NORTH_MACEDONIA',
    Norway: 'NORWAY',
    Oman: 'OMAN',
    Pakistan: 'PAKISTAN',
    Palau: 'PALAU',
    Palestine: 'PALESTINE',
    Panama: 'PANAMA',
    PapuaNewGuinea: 'PAPUA_NEW_GUINEA',
    Paraguay: 'PARAGUAY',
    Peru: 'PERU',
    Philippines: 'PHILIPPINES',
    Poland: 'POLAND',
    Portugal: 'PORTUGAL',
    Qatar: 'QATAR',
    Romania: 'ROMANIA',
    Russia: 'RUSSIA',
    Rwanda: 'RWANDA',
    SaintKittsAndNevis: 'SAINT_KITTS_AND_NEVIS',
    SaintLucia: 'SAINT_LUCIA',
    SaintVincentAndTheGrenadines: 'SAINT_VINCENT_AND_THE_GRENADINES',
    Samoa: 'SAMOA',
    SanMarino: 'SAN_MARINO',
    SaoTomeAndPrincipe: 'SAO_TOME_AND_PRINCIPE',
    SaudiArabia: 'SAUDI_ARABIA',
    Senegal: 'SENEGAL',
    Serbia: 'SERBIA',
    Seychelles: 'SEYCHELLES',
    SierraLeone: 'SIERRA_LEONE',
    Singapore: 'SINGAPORE',
    Slovakia: 'SLOVAKIA',
    Slovenia: 'SLOVENIA',
    SolomonIslands: 'SOLOMON_ISLANDS',
    Somalia: 'SOMALIA',
    SouthAfrica: 'SOUTH_AFRICA',
    SouthKorea: 'SOUTH_KOREA',
    SouthSudan: 'SOUTH_SUDAN',
    Spain: 'SPAIN',
    SriLanka: 'SRI_LANKA',
    Sudan: 'SUDAN',
    Suriname: 'SURINAME',
    Sweden: 'SWEDEN',
    Switzerland: 'SWITZERLAND',
    Syria: 'SYRIA',
    Taiwan: 'TAIWAN',
    Tajikistan: 'TAJIKISTAN',
    Tanzania: 'TANZANIA',
    Thailand: 'THAILAND',
    TimorLeste: 'TIMOR_LESTE',
    Togo: 'TOGO',
    Tonga: 'TONGA',
    TrinidadAndTobago: 'TRINIDAD_AND_TOBAGO',
    Tunisia: 'TUNISIA',
    Turkey: 'TURKEY',
    Turkmenistan: 'TURKMENISTAN',
    Tuvalu: 'TUVALU',
    Uganda: 'UGANDA',
    Ukraine: 'UKRAINE',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    UnitedKingdom: 'UNITED_KINGDOM',
    UnitedStates: 'UNITED_STATES',
    Uruguay: 'URUGUAY',
    Uzbekistan: 'UZBEKISTAN',
    Vanuatu: 'VANUATU',
    VaticanCity: 'VATICAN_CITY',
    Venezuela: 'VENEZUELA',
    Vietnam: 'VIETNAM',
    Yemen: 'YEMEN',
    Zambia: 'ZAMBIA',
    Zimbabwe: 'ZIMBABWE'
} as const;

export type ArtistDTOCountryEnum = typeof ArtistDTOCountryEnum[keyof typeof ArtistDTOCountryEnum];

export interface ArtistResponseDTO {
    /**
     * The id of the artist
     */
    'id': number;
    /**
     * The full biography of the artist
     */
    'biography': string;
    /**
     * The first name of the artist
     */
    'firstName': string;
    /**
     * The last name of the artist
     */
    'lastName': string;
    /**
     * A short biography of the artist
     */
    'shortBiography': string;
    /**
     * The artist\'s profile picture content hash
     */
    'profilePicture': string;
    /**
     * Social media links of the artist
     */
    'socialMedia': { [key: string]: string; };
    /**
     * The country of the artist
     */
    'country'?: ArtistResponseDTOCountryEnum;
}

export const ArtistResponseDTOCountryEnum = {
    NoSelection: 'NO_SELECTION',
    Afghanistan: 'AFGHANISTAN',
    Albania: 'ALBANIA',
    Algeria: 'ALGERIA',
    Andorra: 'ANDORRA',
    Angola: 'ANGOLA',
    AntiguaAndBarbuda: 'ANTIGUA_AND_BARBUDA',
    Argentina: 'ARGENTINA',
    Armenia: 'ARMENIA',
    Australia: 'AUSTRALIA',
    Austria: 'AUSTRIA',
    Azerbaijan: 'AZERBAIJAN',
    Bahamas: 'BAHAMAS',
    Bahrain: 'BAHRAIN',
    Bangladesh: 'BANGLADESH',
    Barbados: 'BARBADOS',
    Belarus: 'BELARUS',
    Belgium: 'BELGIUM',
    Belize: 'BELIZE',
    Benin: 'BENIN',
    Bhutan: 'BHUTAN',
    Bolivia: 'BOLIVIA',
    BosniaAndHerzegovina: 'BOSNIA_AND_HERZEGOVINA',
    Botswana: 'BOTSWANA',
    Brazil: 'BRAZIL',
    Brunei: 'BRUNEI',
    Bulgaria: 'BULGARIA',
    BurkinaFaso: 'BURKINA_FASO',
    Burundi: 'BURUNDI',
    CaboVerde: 'CABO_VERDE',
    Cambodia: 'CAMBODIA',
    Cameroon: 'CAMEROON',
    Canada: 'CANADA',
    CentralAfricanRepublic: 'CENTRAL_AFRICAN_REPUBLIC',
    Chad: 'CHAD',
    Chile: 'CHILE',
    China: 'CHINA',
    Colombia: 'COLOMBIA',
    Comoros: 'COMOROS',
    CongoBrazzaville: 'CONGO_BRAZZAVILLE',
    CongoKinshasa: 'CONGO_KINSHASA',
    CostaRica: 'COSTA_RICA',
    Croatia: 'CROATIA',
    Cuba: 'CUBA',
    Cyprus: 'CYPRUS',
    CzechRepublic: 'CZECH_REPUBLIC',
    Denmark: 'DENMARK',
    Djibouti: 'DJIBOUTI',
    Dominica: 'DOMINICA',
    DominicanRepublic: 'DOMINICAN_REPUBLIC',
    Ecuador: 'ECUADOR',
    Egypt: 'EGYPT',
    ElSalvador: 'EL_SALVADOR',
    EquatorialGuinea: 'EQUATORIAL_GUINEA',
    Eritrea: 'ERITREA',
    Estonia: 'ESTONIA',
    Eswatini: 'ESWATINI',
    Ethiopia: 'ETHIOPIA',
    Fiji: 'FIJI',
    Finland: 'FINLAND',
    France: 'FRANCE',
    Gabon: 'GABON',
    Gambia: 'GAMBIA',
    Georgia: 'GEORGIA',
    Germany: 'GERMANY',
    Ghana: 'GHANA',
    Greece: 'GREECE',
    Grenada: 'GRENADA',
    Guatemala: 'GUATEMALA',
    Guinea: 'GUINEA',
    GuineaBissau: 'GUINEA_BISSAU',
    Guyana: 'GUYANA',
    Haiti: 'HAITI',
    Honduras: 'HONDURAS',
    Hungary: 'HUNGARY',
    Iceland: 'ICELAND',
    India: 'INDIA',
    Indonesia: 'INDONESIA',
    Iran: 'IRAN',
    Iraq: 'IRAQ',
    Ireland: 'IRELAND',
    Israel: 'ISRAEL',
    Italy: 'ITALY',
    IvoryCoast: 'IVORY_COAST',
    Jamaica: 'JAMAICA',
    Japan: 'JAPAN',
    Jordan: 'JORDAN',
    Kazakhstan: 'KAZAKHSTAN',
    Kenya: 'KENYA',
    Kiribati: 'KIRIBATI',
    Kosovo: 'KOSOVO',
    Kuwait: 'KUWAIT',
    Kyrgyzstan: 'KYRGYZSTAN',
    Laos: 'LAOS',
    Latvia: 'LATVIA',
    Lebanon: 'LEBANON',
    Lesotho: 'LESOTHO',
    Liberia: 'LIBERIA',
    Libya: 'LIBYA',
    Liechtenstein: 'LIECHTENSTEIN',
    Lithuania: 'LITHUANIA',
    Luxembourg: 'LUXEMBOURG',
    Madagascar: 'MADAGASCAR',
    Malawi: 'MALAWI',
    Malaysia: 'MALAYSIA',
    Maldives: 'MALDIVES',
    Mali: 'MALI',
    Malta: 'MALTA',
    MarshallIslands: 'MARSHALL_ISLANDS',
    Mauritania: 'MAURITANIA',
    Mauritius: 'MAURITIUS',
    Mexico: 'MEXICO',
    Micronesia: 'MICRONESIA',
    Moldova: 'MOLDOVA',
    Monaco: 'MONACO',
    Mongolia: 'MONGOLIA',
    Montenegro: 'MONTENEGRO',
    Morocco: 'MOROCCO',
    Mozambique: 'MOZAMBIQUE',
    Myanmar: 'MYANMAR',
    Namibia: 'NAMIBIA',
    Nauru: 'NAURU',
    Nepal: 'NEPAL',
    Netherlands: 'NETHERLANDS',
    NewZealand: 'NEW_ZEALAND',
    Nicaragua: 'NICARAGUA',
    Niger: 'NIGER',
    Nigeria: 'NIGERIA',
    NorthKorea: 'NORTH_KOREA',
    NorthMacedonia: 'NORTH_MACEDONIA',
    Norway: 'NORWAY',
    Oman: 'OMAN',
    Pakistan: 'PAKISTAN',
    Palau: 'PALAU',
    Palestine: 'PALESTINE',
    Panama: 'PANAMA',
    PapuaNewGuinea: 'PAPUA_NEW_GUINEA',
    Paraguay: 'PARAGUAY',
    Peru: 'PERU',
    Philippines: 'PHILIPPINES',
    Poland: 'POLAND',
    Portugal: 'PORTUGAL',
    Qatar: 'QATAR',
    Romania: 'ROMANIA',
    Russia: 'RUSSIA',
    Rwanda: 'RWANDA',
    SaintKittsAndNevis: 'SAINT_KITTS_AND_NEVIS',
    SaintLucia: 'SAINT_LUCIA',
    SaintVincentAndTheGrenadines: 'SAINT_VINCENT_AND_THE_GRENADINES',
    Samoa: 'SAMOA',
    SanMarino: 'SAN_MARINO',
    SaoTomeAndPrincipe: 'SAO_TOME_AND_PRINCIPE',
    SaudiArabia: 'SAUDI_ARABIA',
    Senegal: 'SENEGAL',
    Serbia: 'SERBIA',
    Seychelles: 'SEYCHELLES',
    SierraLeone: 'SIERRA_LEONE',
    Singapore: 'SINGAPORE',
    Slovakia: 'SLOVAKIA',
    Slovenia: 'SLOVENIA',
    SolomonIslands: 'SOLOMON_ISLANDS',
    Somalia: 'SOMALIA',
    SouthAfrica: 'SOUTH_AFRICA',
    SouthKorea: 'SOUTH_KOREA',
    SouthSudan: 'SOUTH_SUDAN',
    Spain: 'SPAIN',
    SriLanka: 'SRI_LANKA',
    Sudan: 'SUDAN',
    Suriname: 'SURINAME',
    Sweden: 'SWEDEN',
    Switzerland: 'SWITZERLAND',
    Syria: 'SYRIA',
    Taiwan: 'TAIWAN',
    Tajikistan: 'TAJIKISTAN',
    Tanzania: 'TANZANIA',
    Thailand: 'THAILAND',
    TimorLeste: 'TIMOR_LESTE',
    Togo: 'TOGO',
    Tonga: 'TONGA',
    TrinidadAndTobago: 'TRINIDAD_AND_TOBAGO',
    Tunisia: 'TUNISIA',
    Turkey: 'TURKEY',
    Turkmenistan: 'TURKMENISTAN',
    Tuvalu: 'TUVALU',
    Uganda: 'UGANDA',
    Ukraine: 'UKRAINE',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    UnitedKingdom: 'UNITED_KINGDOM',
    UnitedStates: 'UNITED_STATES',
    Uruguay: 'URUGUAY',
    Uzbekistan: 'UZBEKISTAN',
    Vanuatu: 'VANUATU',
    VaticanCity: 'VATICAN_CITY',
    Venezuela: 'VENEZUELA',
    Vietnam: 'VIETNAM',
    Yemen: 'YEMEN',
    Zambia: 'ZAMBIA',
    Zimbabwe: 'ZIMBABWE'
} as const;

export type ArtistResponseDTOCountryEnum = typeof ArtistResponseDTOCountryEnum[keyof typeof ArtistResponseDTOCountryEnum];

export interface ArtistResponseDTOFull {
    /**
     * The id of the artist
     */
    'id': number;
    /**
     * If the artist is verified
     */
    'verified': boolean;
    /**
     * If the artist is a noUser
     */
    'noUser': boolean;
    /**
     * If the artist is an admin
     */
    'admin': boolean;
    /**
     * The artist\'s name
     */
    'name': string;
    /**
     * The artist\'s name reversed
     */
    'nameReversed': string;
    /**
     * The artist\'s pieces
     */
    'pieces': Array<PieceResponseDTOSimple>;
    /**
     * The artist\'s contributions
     */
    'contributions': Array<ContributionResponseDTO>;
    /**
     * The artist\'s profile
     */
    'artistProfile': ArtistResponseDTO;
    /**
     * If the artist is yellow (has no pieces)
     */
    'yellow': boolean;
    /**
     * The country of the artist
     */
    'country'?: ArtistResponseDTOFullCountryEnum;
}

export const ArtistResponseDTOFullCountryEnum = {
    NoSelection: 'NO_SELECTION',
    Afghanistan: 'AFGHANISTAN',
    Albania: 'ALBANIA',
    Algeria: 'ALGERIA',
    Andorra: 'ANDORRA',
    Angola: 'ANGOLA',
    AntiguaAndBarbuda: 'ANTIGUA_AND_BARBUDA',
    Argentina: 'ARGENTINA',
    Armenia: 'ARMENIA',
    Australia: 'AUSTRALIA',
    Austria: 'AUSTRIA',
    Azerbaijan: 'AZERBAIJAN',
    Bahamas: 'BAHAMAS',
    Bahrain: 'BAHRAIN',
    Bangladesh: 'BANGLADESH',
    Barbados: 'BARBADOS',
    Belarus: 'BELARUS',
    Belgium: 'BELGIUM',
    Belize: 'BELIZE',
    Benin: 'BENIN',
    Bhutan: 'BHUTAN',
    Bolivia: 'BOLIVIA',
    BosniaAndHerzegovina: 'BOSNIA_AND_HERZEGOVINA',
    Botswana: 'BOTSWANA',
    Brazil: 'BRAZIL',
    Brunei: 'BRUNEI',
    Bulgaria: 'BULGARIA',
    BurkinaFaso: 'BURKINA_FASO',
    Burundi: 'BURUNDI',
    CaboVerde: 'CABO_VERDE',
    Cambodia: 'CAMBODIA',
    Cameroon: 'CAMEROON',
    Canada: 'CANADA',
    CentralAfricanRepublic: 'CENTRAL_AFRICAN_REPUBLIC',
    Chad: 'CHAD',
    Chile: 'CHILE',
    China: 'CHINA',
    Colombia: 'COLOMBIA',
    Comoros: 'COMOROS',
    CongoBrazzaville: 'CONGO_BRAZZAVILLE',
    CongoKinshasa: 'CONGO_KINSHASA',
    CostaRica: 'COSTA_RICA',
    Croatia: 'CROATIA',
    Cuba: 'CUBA',
    Cyprus: 'CYPRUS',
    CzechRepublic: 'CZECH_REPUBLIC',
    Denmark: 'DENMARK',
    Djibouti: 'DJIBOUTI',
    Dominica: 'DOMINICA',
    DominicanRepublic: 'DOMINICAN_REPUBLIC',
    Ecuador: 'ECUADOR',
    Egypt: 'EGYPT',
    ElSalvador: 'EL_SALVADOR',
    EquatorialGuinea: 'EQUATORIAL_GUINEA',
    Eritrea: 'ERITREA',
    Estonia: 'ESTONIA',
    Eswatini: 'ESWATINI',
    Ethiopia: 'ETHIOPIA',
    Fiji: 'FIJI',
    Finland: 'FINLAND',
    France: 'FRANCE',
    Gabon: 'GABON',
    Gambia: 'GAMBIA',
    Georgia: 'GEORGIA',
    Germany: 'GERMANY',
    Ghana: 'GHANA',
    Greece: 'GREECE',
    Grenada: 'GRENADA',
    Guatemala: 'GUATEMALA',
    Guinea: 'GUINEA',
    GuineaBissau: 'GUINEA_BISSAU',
    Guyana: 'GUYANA',
    Haiti: 'HAITI',
    Honduras: 'HONDURAS',
    Hungary: 'HUNGARY',
    Iceland: 'ICELAND',
    India: 'INDIA',
    Indonesia: 'INDONESIA',
    Iran: 'IRAN',
    Iraq: 'IRAQ',
    Ireland: 'IRELAND',
    Israel: 'ISRAEL',
    Italy: 'ITALY',
    IvoryCoast: 'IVORY_COAST',
    Jamaica: 'JAMAICA',
    Japan: 'JAPAN',
    Jordan: 'JORDAN',
    Kazakhstan: 'KAZAKHSTAN',
    Kenya: 'KENYA',
    Kiribati: 'KIRIBATI',
    Kosovo: 'KOSOVO',
    Kuwait: 'KUWAIT',
    Kyrgyzstan: 'KYRGYZSTAN',
    Laos: 'LAOS',
    Latvia: 'LATVIA',
    Lebanon: 'LEBANON',
    Lesotho: 'LESOTHO',
    Liberia: 'LIBERIA',
    Libya: 'LIBYA',
    Liechtenstein: 'LIECHTENSTEIN',
    Lithuania: 'LITHUANIA',
    Luxembourg: 'LUXEMBOURG',
    Madagascar: 'MADAGASCAR',
    Malawi: 'MALAWI',
    Malaysia: 'MALAYSIA',
    Maldives: 'MALDIVES',
    Mali: 'MALI',
    Malta: 'MALTA',
    MarshallIslands: 'MARSHALL_ISLANDS',
    Mauritania: 'MAURITANIA',
    Mauritius: 'MAURITIUS',
    Mexico: 'MEXICO',
    Micronesia: 'MICRONESIA',
    Moldova: 'MOLDOVA',
    Monaco: 'MONACO',
    Mongolia: 'MONGOLIA',
    Montenegro: 'MONTENEGRO',
    Morocco: 'MOROCCO',
    Mozambique: 'MOZAMBIQUE',
    Myanmar: 'MYANMAR',
    Namibia: 'NAMIBIA',
    Nauru: 'NAURU',
    Nepal: 'NEPAL',
    Netherlands: 'NETHERLANDS',
    NewZealand: 'NEW_ZEALAND',
    Nicaragua: 'NICARAGUA',
    Niger: 'NIGER',
    Nigeria: 'NIGERIA',
    NorthKorea: 'NORTH_KOREA',
    NorthMacedonia: 'NORTH_MACEDONIA',
    Norway: 'NORWAY',
    Oman: 'OMAN',
    Pakistan: 'PAKISTAN',
    Palau: 'PALAU',
    Palestine: 'PALESTINE',
    Panama: 'PANAMA',
    PapuaNewGuinea: 'PAPUA_NEW_GUINEA',
    Paraguay: 'PARAGUAY',
    Peru: 'PERU',
    Philippines: 'PHILIPPINES',
    Poland: 'POLAND',
    Portugal: 'PORTUGAL',
    Qatar: 'QATAR',
    Romania: 'ROMANIA',
    Russia: 'RUSSIA',
    Rwanda: 'RWANDA',
    SaintKittsAndNevis: 'SAINT_KITTS_AND_NEVIS',
    SaintLucia: 'SAINT_LUCIA',
    SaintVincentAndTheGrenadines: 'SAINT_VINCENT_AND_THE_GRENADINES',
    Samoa: 'SAMOA',
    SanMarino: 'SAN_MARINO',
    SaoTomeAndPrincipe: 'SAO_TOME_AND_PRINCIPE',
    SaudiArabia: 'SAUDI_ARABIA',
    Senegal: 'SENEGAL',
    Serbia: 'SERBIA',
    Seychelles: 'SEYCHELLES',
    SierraLeone: 'SIERRA_LEONE',
    Singapore: 'SINGAPORE',
    Slovakia: 'SLOVAKIA',
    Slovenia: 'SLOVENIA',
    SolomonIslands: 'SOLOMON_ISLANDS',
    Somalia: 'SOMALIA',
    SouthAfrica: 'SOUTH_AFRICA',
    SouthKorea: 'SOUTH_KOREA',
    SouthSudan: 'SOUTH_SUDAN',
    Spain: 'SPAIN',
    SriLanka: 'SRI_LANKA',
    Sudan: 'SUDAN',
    Suriname: 'SURINAME',
    Sweden: 'SWEDEN',
    Switzerland: 'SWITZERLAND',
    Syria: 'SYRIA',
    Taiwan: 'TAIWAN',
    Tajikistan: 'TAJIKISTAN',
    Tanzania: 'TANZANIA',
    Thailand: 'THAILAND',
    TimorLeste: 'TIMOR_LESTE',
    Togo: 'TOGO',
    Tonga: 'TONGA',
    TrinidadAndTobago: 'TRINIDAD_AND_TOBAGO',
    Tunisia: 'TUNISIA',
    Turkey: 'TURKEY',
    Turkmenistan: 'TURKMENISTAN',
    Tuvalu: 'TUVALU',
    Uganda: 'UGANDA',
    Ukraine: 'UKRAINE',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    UnitedKingdom: 'UNITED_KINGDOM',
    UnitedStates: 'UNITED_STATES',
    Uruguay: 'URUGUAY',
    Uzbekistan: 'UZBEKISTAN',
    Vanuatu: 'VANUATU',
    VaticanCity: 'VATICAN_CITY',
    Venezuela: 'VENEZUELA',
    Vietnam: 'VIETNAM',
    Yemen: 'YEMEN',
    Zambia: 'ZAMBIA',
    Zimbabwe: 'ZIMBABWE'
} as const;

export type ArtistResponseDTOFullCountryEnum = typeof ArtistResponseDTOFullCountryEnum[keyof typeof ArtistResponseDTOFullCountryEnum];

export interface ArtistResponseDTOMin {
    /**
     * The id of the artist
     */
    'id': number;
    /**
     * If the artist is verified
     */
    'verified': boolean;
    /**
     * If the artist is a noUser
     */
    'noUser': boolean;
    /**
     * The artist\'s name
     */
    'name': string;
    /**
     * The artist\'s profile picture content hash
     */
    'profilePicture': string;
    /**
     * The artist\'s short description
     */
    'shortBiography': string;
}
export interface AssetCreateDTO {
    'altText'?: string;
}
export interface AssetResponseDTO {
    /**
     * The asset id
     */
    'id': number;
    /**
     * Content hash of the asset (SHA-256)
     */
    'contentHash': string;
    /**
     * File extension including the dot (e.g., .jpg, .png)
     */
    'fileExtension'?: string;
    /**
     * MIME type of the asset (e.g., image/png, application/pdf)
     */
    'mimeType': string;
    /**
     * Original filename of the asset as provided during upload
     */
    'originalFilename': string;
    /**
     * File size of the asset in bytes
     */
    'fileSize'?: number;
    /**
     * Alt text for the asset (if applicable)
     */
    'altText'?: string;
    /**
     * Upload timestamp of the asset
     */
    'uploadedAt'?: string;
    /**
     * Storage path of the asset in the server\'s file system
     */
    'storagePath': string;
}
export interface ConfirmedMessageDto {
    'confirmed'?: boolean;
    'message'?: string;
}
export interface ConfirmedMessageResponseDTO {
    /**
     * The ID of the confirmed message
     */
    'id': number;
    /**
     * The piece associated with the confirmed message
     */
    'piece': PieceResponseDTOMin;
    /**
     * The account that confirmed the message
     */
    'confirmedBy': string;
    /**
     * The ID of the piece associated with the confirmed message
     */
    'message': string;
    /**
     * The Date when the message was created
     */
    'date': string;
    /**
     * Whether the message is confirmed or not
     */
    'confirmed': boolean;
    /**
     * The Date when the message was last edited, null if never edited
     */
    'editedDate'?: string;
    /**
     * Whether the message has been edited or not
     */
    'edited': boolean;
}
export interface ContributionResponseDTO {
    /**
     * The contribution type the author has on the piece
     */
    'contributionType': string;
    /**
     * The piece
     */
    'piece': PieceResponseDTOSimple;
}
export interface ContributorDTO {
    /**
     * The contributor type
     */
    'type': string;
    /**
     * The artist ID of the contributor
     */
    'artistId'?: number;
    /**
     * The name of the contributor. If artist Id empty
     */
    'name'?: string;
}
export interface ContributorResponseDTO {
    /**
     * The id of the contributor
     */
    'id': number;
    /**
     * The type of the contributor
     */
    'type': string;
    /**
     * The artist id of the contributor
     */
    'artistId': number;
    /**
     * The name of the contributor
     */
    'name': string;
    /**
     * The artist
     */
    'artist': ArtistResponseDTOMin;
}
export interface CountryAmountDTO {
    /**
     * The country of the composer
     */
    'country': CountryAmountDTOCountryEnum;
    /**
     * The amount of pieces that have a composer from the country
     */
    'amount': number;
}

export const CountryAmountDTOCountryEnum = {
    NoSelection: 'NO_SELECTION',
    Afghanistan: 'AFGHANISTAN',
    Albania: 'ALBANIA',
    Algeria: 'ALGERIA',
    Andorra: 'ANDORRA',
    Angola: 'ANGOLA',
    AntiguaAndBarbuda: 'ANTIGUA_AND_BARBUDA',
    Argentina: 'ARGENTINA',
    Armenia: 'ARMENIA',
    Australia: 'AUSTRALIA',
    Austria: 'AUSTRIA',
    Azerbaijan: 'AZERBAIJAN',
    Bahamas: 'BAHAMAS',
    Bahrain: 'BAHRAIN',
    Bangladesh: 'BANGLADESH',
    Barbados: 'BARBADOS',
    Belarus: 'BELARUS',
    Belgium: 'BELGIUM',
    Belize: 'BELIZE',
    Benin: 'BENIN',
    Bhutan: 'BHUTAN',
    Bolivia: 'BOLIVIA',
    BosniaAndHerzegovina: 'BOSNIA_AND_HERZEGOVINA',
    Botswana: 'BOTSWANA',
    Brazil: 'BRAZIL',
    Brunei: 'BRUNEI',
    Bulgaria: 'BULGARIA',
    BurkinaFaso: 'BURKINA_FASO',
    Burundi: 'BURUNDI',
    CaboVerde: 'CABO_VERDE',
    Cambodia: 'CAMBODIA',
    Cameroon: 'CAMEROON',
    Canada: 'CANADA',
    CentralAfricanRepublic: 'CENTRAL_AFRICAN_REPUBLIC',
    Chad: 'CHAD',
    Chile: 'CHILE',
    China: 'CHINA',
    Colombia: 'COLOMBIA',
    Comoros: 'COMOROS',
    CongoBrazzaville: 'CONGO_BRAZZAVILLE',
    CongoKinshasa: 'CONGO_KINSHASA',
    CostaRica: 'COSTA_RICA',
    Croatia: 'CROATIA',
    Cuba: 'CUBA',
    Cyprus: 'CYPRUS',
    CzechRepublic: 'CZECH_REPUBLIC',
    Denmark: 'DENMARK',
    Djibouti: 'DJIBOUTI',
    Dominica: 'DOMINICA',
    DominicanRepublic: 'DOMINICAN_REPUBLIC',
    Ecuador: 'ECUADOR',
    Egypt: 'EGYPT',
    ElSalvador: 'EL_SALVADOR',
    EquatorialGuinea: 'EQUATORIAL_GUINEA',
    Eritrea: 'ERITREA',
    Estonia: 'ESTONIA',
    Eswatini: 'ESWATINI',
    Ethiopia: 'ETHIOPIA',
    Fiji: 'FIJI',
    Finland: 'FINLAND',
    France: 'FRANCE',
    Gabon: 'GABON',
    Gambia: 'GAMBIA',
    Georgia: 'GEORGIA',
    Germany: 'GERMANY',
    Ghana: 'GHANA',
    Greece: 'GREECE',
    Grenada: 'GRENADA',
    Guatemala: 'GUATEMALA',
    Guinea: 'GUINEA',
    GuineaBissau: 'GUINEA_BISSAU',
    Guyana: 'GUYANA',
    Haiti: 'HAITI',
    Honduras: 'HONDURAS',
    Hungary: 'HUNGARY',
    Iceland: 'ICELAND',
    India: 'INDIA',
    Indonesia: 'INDONESIA',
    Iran: 'IRAN',
    Iraq: 'IRAQ',
    Ireland: 'IRELAND',
    Israel: 'ISRAEL',
    Italy: 'ITALY',
    IvoryCoast: 'IVORY_COAST',
    Jamaica: 'JAMAICA',
    Japan: 'JAPAN',
    Jordan: 'JORDAN',
    Kazakhstan: 'KAZAKHSTAN',
    Kenya: 'KENYA',
    Kiribati: 'KIRIBATI',
    Kosovo: 'KOSOVO',
    Kuwait: 'KUWAIT',
    Kyrgyzstan: 'KYRGYZSTAN',
    Laos: 'LAOS',
    Latvia: 'LATVIA',
    Lebanon: 'LEBANON',
    Lesotho: 'LESOTHO',
    Liberia: 'LIBERIA',
    Libya: 'LIBYA',
    Liechtenstein: 'LIECHTENSTEIN',
    Lithuania: 'LITHUANIA',
    Luxembourg: 'LUXEMBOURG',
    Madagascar: 'MADAGASCAR',
    Malawi: 'MALAWI',
    Malaysia: 'MALAYSIA',
    Maldives: 'MALDIVES',
    Mali: 'MALI',
    Malta: 'MALTA',
    MarshallIslands: 'MARSHALL_ISLANDS',
    Mauritania: 'MAURITANIA',
    Mauritius: 'MAURITIUS',
    Mexico: 'MEXICO',
    Micronesia: 'MICRONESIA',
    Moldova: 'MOLDOVA',
    Monaco: 'MONACO',
    Mongolia: 'MONGOLIA',
    Montenegro: 'MONTENEGRO',
    Morocco: 'MOROCCO',
    Mozambique: 'MOZAMBIQUE',
    Myanmar: 'MYANMAR',
    Namibia: 'NAMIBIA',
    Nauru: 'NAURU',
    Nepal: 'NEPAL',
    Netherlands: 'NETHERLANDS',
    NewZealand: 'NEW_ZEALAND',
    Nicaragua: 'NICARAGUA',
    Niger: 'NIGER',
    Nigeria: 'NIGERIA',
    NorthKorea: 'NORTH_KOREA',
    NorthMacedonia: 'NORTH_MACEDONIA',
    Norway: 'NORWAY',
    Oman: 'OMAN',
    Pakistan: 'PAKISTAN',
    Palau: 'PALAU',
    Palestine: 'PALESTINE',
    Panama: 'PANAMA',
    PapuaNewGuinea: 'PAPUA_NEW_GUINEA',
    Paraguay: 'PARAGUAY',
    Peru: 'PERU',
    Philippines: 'PHILIPPINES',
    Poland: 'POLAND',
    Portugal: 'PORTUGAL',
    Qatar: 'QATAR',
    Romania: 'ROMANIA',
    Russia: 'RUSSIA',
    Rwanda: 'RWANDA',
    SaintKittsAndNevis: 'SAINT_KITTS_AND_NEVIS',
    SaintLucia: 'SAINT_LUCIA',
    SaintVincentAndTheGrenadines: 'SAINT_VINCENT_AND_THE_GRENADINES',
    Samoa: 'SAMOA',
    SanMarino: 'SAN_MARINO',
    SaoTomeAndPrincipe: 'SAO_TOME_AND_PRINCIPE',
    SaudiArabia: 'SAUDI_ARABIA',
    Senegal: 'SENEGAL',
    Serbia: 'SERBIA',
    Seychelles: 'SEYCHELLES',
    SierraLeone: 'SIERRA_LEONE',
    Singapore: 'SINGAPORE',
    Slovakia: 'SLOVAKIA',
    Slovenia: 'SLOVENIA',
    SolomonIslands: 'SOLOMON_ISLANDS',
    Somalia: 'SOMALIA',
    SouthAfrica: 'SOUTH_AFRICA',
    SouthKorea: 'SOUTH_KOREA',
    SouthSudan: 'SOUTH_SUDAN',
    Spain: 'SPAIN',
    SriLanka: 'SRI_LANKA',
    Sudan: 'SUDAN',
    Suriname: 'SURINAME',
    Sweden: 'SWEDEN',
    Switzerland: 'SWITZERLAND',
    Syria: 'SYRIA',
    Taiwan: 'TAIWAN',
    Tajikistan: 'TAJIKISTAN',
    Tanzania: 'TANZANIA',
    Thailand: 'THAILAND',
    TimorLeste: 'TIMOR_LESTE',
    Togo: 'TOGO',
    Tonga: 'TONGA',
    TrinidadAndTobago: 'TRINIDAD_AND_TOBAGO',
    Tunisia: 'TUNISIA',
    Turkey: 'TURKEY',
    Turkmenistan: 'TURKMENISTAN',
    Tuvalu: 'TUVALU',
    Uganda: 'UGANDA',
    Ukraine: 'UKRAINE',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    UnitedKingdom: 'UNITED_KINGDOM',
    UnitedStates: 'UNITED_STATES',
    Uruguay: 'URUGUAY',
    Uzbekistan: 'UZBEKISTAN',
    Vanuatu: 'VANUATU',
    VaticanCity: 'VATICAN_CITY',
    Venezuela: 'VENEZUELA',
    Vietnam: 'VIETNAM',
    Yemen: 'YEMEN',
    Zambia: 'ZAMBIA',
    Zimbabwe: 'ZIMBABWE'
} as const;

export type CountryAmountDTOCountryEnum = typeof CountryAmountDTOCountryEnum[keyof typeof CountryAmountDTOCountryEnum];

export interface DownloadResponseDTO {
    /**
     * The of the piece
     */
    'pieceTitle': string;
    /**
     * The pieces id
     */
    'pieceId': number;
    /**
     * The composer\'s name
     */
    'composerName': string;
    /**
     * The composer\'s id
     */
    'composerId': number;
    /**
     * The price if purchase
     */
    'price': number;
    /**
     * The date of the download
     */
    'date': string;
}
export interface FindArtistDTO {
    /**
     * The search query
     */
    'query': string;
}
export interface InstrumentAmountDTO {
    /**
     * The instrument
     */
    'instrument': InstrumentAmountDTOInstrumentEnum;
    /**
     * The instruments amount
     */
    'amount': number;
}

export const InstrumentAmountDTOInstrumentEnum = {
    Other: 'Other',
    Accordion: 'Accordion',
    Violin: 'Violin',
    Cello: 'Cello',
    Viola: 'Viola',
    DoubleBass: 'Double_bass',
    Recorder: 'Recorder',
    Guitar: 'Guitar',
    ElectricGuitar: 'Electric_Guitar',
    AcousticGuitar: 'Acoustic_Guitar',
    Piano: 'Piano',
    Organ: 'Organ',
    Bagpipes: 'Bagpipes',
    Banjo: 'Banjo',
    Bassoon: 'Bassoon',
    Bongo: 'Bongo',
    Clarinet: 'Clarinet',
    AltoClarinet: 'Alto_Clarinet',
    BassClarinet: 'Bass_Clarinet',
    ContrabassClarinet: 'Contrabass_Clarinet',
    PiccoloClarinet: 'Piccolo_Clarinet',
    SopraninoClarinet: 'Sopranino_Clarinet',
    Clavichord: 'Clavichord',
    Cymbal: 'Cymbal',
    Dhime: 'Dhime',
    Didgeridoo: 'Didgeridoo',
    DrumKit: 'Drum_kit',
    Euphonium: 'Euphonium',
    Flute: 'Flute',
    AltoFlute: 'Alto_Flute',
    BassFlute: 'Bass_Flute',
    ContraaltoFlute: 'Contraalto_Flute',
    ContrabassFlute: 'Contrabass_Flute',
    SubcontrabassFlute: 'Subcontrabass_Flute',
    DoubleContrabssFlute: 'Double_contrabss_Flute',
    HyperbassFlute: 'Hyperbass_Flute',
    FrenchHorn: 'French_horn',
    GlassHarmonica: 'Glass_harmonica',
    Glockenspiel: 'Glockenspiel',
    Gong: 'Gong',
    Harmonica: 'Harmonica',
    Harmonium: 'Harmonium',
    Harp: 'Harp',
    Harpsichord: 'Harpsichord',
    Kalimba: 'Kalimba',
    Lute: 'Lute',
    Mandolin: 'Mandolin',
    Marimba: 'Marimba',
    Melodica: 'Melodica',
    Oboe: 'Oboe',
    BassBaritoneOboe: 'BassBaritone_Oboe',
    ContrabassOboe: 'Contrabass_Oboe',
    EnglishHorn: 'English_horn',
    PiccoloOboe: 'Piccolo_Oboe',
    Octobass: 'Octobass',
    Pianola: 'Pianola',
    Piccolo: 'Piccolo',
    Saxophone: 'Saxophone',
    AltoSaxophone: 'Alto_Saxophone',
    BaritoneSaxophone: 'Baritone_Saxophone',
    BassSaxophone: 'Bass_Saxophone',
    ContrabassSaxophone: 'Contrabass_Saxophone',
    SopranoSaxophone: 'Soprano_Saxophone',
    TenorSaxophone: 'Tenor_Saxophone',
    SopraninoSaxophone: 'Sopranino_Saxophone',
    Steelpan: 'Steelpan',
    Stylophone: 'Stylophone',
    Synthesizer: 'Synthesizer',
    Tambourine: 'Tambourine',
    Timpani: 'Timpani',
    Triangle: 'Triangle',
    Trombone: 'Trombone',
    Trumpet: 'Trumpet',
    SopranoTrumpet: 'Soprano_Trumpet',
    BassTrumpet: 'Bass_Trumpet',
    BaroqueTrumpet: 'Baroque_Trumpet',
    PiccoloTrumpet: 'Piccolo_Trumpet',
    Theremin: 'Theremin',
    Tuba: 'Tuba',
    BassTuba: 'Bass_Tuba',
    ContrabassTuba: 'Contrabass_Tuba',
    SubcontrabassTuba: 'Subcontrabass_Tuba',
    Ukulele: 'Ukulele',
    Veena: 'Veena',
    Vibraphone: 'Vibraphone',
    Xylophone: 'Xylophone',
    Zither: 'Zither',
    Electrics: 'Electrics',
    BassAccordion: 'Bass_Accordion'
} as const;

export type InstrumentAmountDTOInstrumentEnum = typeof InstrumentAmountDTOInstrumentEnum[keyof typeof InstrumentAmountDTOInstrumentEnum];

export interface InstrumentGroupDTO {
    'group'?: InstrumentGroupDTOGroupEnum;
}

export const InstrumentGroupDTOGroupEnum = {
    Guitars: 'GUITARS',
    Clarinets: 'CLARINETS',
    Flutes: 'FLUTES',
    Oboes: 'OBOES',
    Saxophones: 'SAXOPHONES',
    Trumpets: 'TRUMPETS'
} as const;

export type InstrumentGroupDTOGroupEnum = typeof InstrumentGroupDTOGroupEnum[keyof typeof InstrumentGroupDTOGroupEnum];

export interface LoginDTO {
    /**
     * Email of the user
     */
    'email': string;
    /**
     * Password of the user
     */
    'password': string;
}
export interface LoginResponseDTO {
    /**
     * Email of the user
     */
    'email': string;
    /**
     * Session ID of the user
     */
    'sessionId': string;
    /**
     * account category of the user
     */
    'category': LoginResponseDTOCategoryEnum;
    /**
     * Artist data of the user
     */
    'artist': ArtistResponseDTOMin;
}

export const LoginResponseDTOCategoryEnum = {
    Normal: 'NORMAL',
    Admin: 'ADMIN',
    Creator: 'CREATOR',
    VerifiedCreator: 'VERIFIED_CREATOR'
} as const;

export type LoginResponseDTOCategoryEnum = typeof LoginResponseDTOCategoryEnum[keyof typeof LoginResponseDTOCategoryEnum];

export interface MainPageResponseDTO {
    /**
     * List of for you pieces for the main page
     */
    'forYou'?: Array<PieceResponseDTOSimple>;
    /**
     * List of most recent pieces for the main page
     */
    'newest': Array<PieceResponseDTOSimple>;
}
export interface OverviewResponseDTO {
    /**
     * If the user can payout his money
     */
    'canPayout': boolean;
    /**
     * The balance the user has
     */
    'balance': number;
}
export interface PayOutDTO {
    /**
     * IBAN of the recipient
     */
    'iban': string;
    /**
     * BIC of the recipient
     */
    'bic': string;
    /**
     * Name of the recipient
     */
    'recipient': string;
}
export interface PayoutResponseDTO {
    /**
     * Pay Out id
     */
    'id': number;
    /**
     * IBAN of the recipient
     */
    'iban': string;
    /**
     * BIC of the recipient
     */
    'bic': string;
    /**
     * Name of the recipient
     */
    'recipient': string;
    /**
     * Amount to be paid out
     */
    'amount': number;
    /**
     * Date of the payout request
     */
    'date': string;
    /**
     * Whether the payout request is closed
     */
    'closed': boolean;
    /**
     * Date when the payout request was closed
     */
    'closedDate'?: string;
    /**
     * The account id
     */
    'artistId': number;
    /**
     * The account id
     */
    'artist': string;
}
export interface PerformanceDTO {
    /**
     * ID of the performer
     */
    'performerId'?: number;
    /**
     * Name of the performer
     */
    'performerName'?: string;
    /**
     * Link to the performance
     */
    'link': string;
    /**
     * Description of the performance
     */
    'description': string;
    /**
     * Type of the performance
     */
    'type': PerformanceDTOTypeEnum;
}

export const PerformanceDTOTypeEnum = {
    Local: 'LOCAL',
    Spotify: 'SPOTIFY',
    Youtube: 'YOUTUBE',
    Soundcloud: 'SOUNDCLOUD'
} as const;

export type PerformanceDTOTypeEnum = typeof PerformanceDTOTypeEnum[keyof typeof PerformanceDTOTypeEnum];

export interface PerformanceResponseDTO {
    /**
     * The id of the performance
     */
    'id': number;
    /**
     * The type of the performance
     */
    'type': PerformanceResponseDTOTypeEnum;
    /**
     * The link to the performance
     */
    'link': string;
    /**
     * The description of the performance
     */
    'description': string;
    /**
     * The performer of the performance
     */
    'performer': ArtistResponseDTOMin;
}

export const PerformanceResponseDTOTypeEnum = {
    Local: 'LOCAL',
    Spotify: 'SPOTIFY',
    Youtube: 'YOUTUBE',
    Soundcloud: 'SOUNDCLOUD'
} as const;

export type PerformanceResponseDTOTypeEnum = typeof PerformanceResponseDTOTypeEnum[keyof typeof PerformanceResponseDTOTypeEnum];

export interface PieceAdminResponseDTO {
    /**
     * The piece
     */
    'piece': PieceResponseDTOSimple;
    /**
     * The piece confirmed status
     */
    'status': PieceAdminResponseDTOStatusEnum;
    /**
     * The piece confirmed message history
     */
    'messageHistory': Array<ConfirmedMessageResponseDTO>;
}

export const PieceAdminResponseDTOStatusEnum = {
    RejectedButEdited: 'REJECTED_BUT_EDITED',
    Pending: 'PENDING',
    Rejected: 'REJECTED',
    Confirmed: 'CONFIRMED'
} as const;

export type PieceAdminResponseDTOStatusEnum = typeof PieceAdminResponseDTOStatusEnum[keyof typeof PieceAdminResponseDTOStatusEnum];

export interface PieceCheckoutResponseDTO {
    /**
     * The stripe checkout response dto
     */
    'stripeCheckout': StripeCheckoutResponseDTO;
    /**
     * The ID of the piece being purchased
     */
    'pieceId': number;
}
export interface PieceDTO {
    /**
     * Title of the piece
     */
    'title': string;
    /**
     * Description of the piece
     */
    'description': string;
    /**
     * Price of the piece
     */
    'price': number;
    /**
     * Duration of the piece in minutes
     */
    'duration': number;
    /**
     * Year when the piece was composed
     */
    'year': number;
    /**
     * Number of pages in the piece
     */
    'pages'?: number;
    /**
     * Difficulty level of the piece
     */
    'difficulty': number;
    /**
     * Original version details of the piece
     */
    'original': boolean;
    /**
     * Instruments involved in the piece
     */
    'instruments': Array<InstrumentAmountDTO>;
    /**
     * Orchestral Instruments involved in the piece
     */
    'orchestralInstruments'?: Array<InstrumentAmountDTO>;
    /**
     * Keywords related to the piece
     */
    'keywords': Array<string>;
    /**
     * Scores related to the piece
     */
    'scores'?: Array<ScoreUpdateDTO>;
    /**
     * Performances of the piece
     */
    'performances': Array<PerformanceDTO>;
    /**
     * Contributors of the piece
     */
    'contributors': Array<ContributorDTO>;
    /**
     * Transcription info for the piece
     */
    'transcriptionInfo'?: TranscriptionInfoDTO;
    /**
     * Thumbnail Hash
     */
    'thumbnailHash'?: string;
    /**
     * Indicates if a custom thumbnail is used
     */
    'customThumbnail': boolean;
    /**
     * Page number from which the thumbnail is generated
     */
    'generateThumbnailFromPage'?: number;
    /**
     * Preview Hash
     */
    'previewHash'?: string;
    /**
     * Number of pages in the preview
     */
    'previewPageCount'?: number;
    /**
     * External link to the score
     */
    'externalScoreLink'?: string;
    /**
     * Movements of the piece
     */
    'movements'?: Array<string>;
}
export interface PieceFilterDTO {
    /**
     * Search query for filtering pieces
     */
    'search': string;
    /**
     * Order option for sorting pieces
     */
    'orderOption': PieceFilterDTOOrderOptionEnum;
    /**
     * Page number for pagination
     */
    'currentPage': number;
    /**
     * Keywords to filter pieces
     */
    'keywords'?: Array<string>;
    /**
     * Instruments to filter pieces
     */
    'instruments'?: Array<InstrumentAmountDTO>;
    /**
     * Total instrument amount to filter pieces
     */
    'totalInstrumentAmount'?: number;
    /**
     * Original flag to filter pieces
     */
    'original'?: boolean;
    /**
     * Duration min
     */
    'durationFrom'?: number;
    /**
     * Duration max
     */
    'durationTo'?: number;
    /**
     * Year min
     */
    'yearFrom'?: number;
    /**
     * Year max
     */
    'yearTo'?: number;
    /**
     * Max Price
     */
    'maxPrice'?: number;
    /**
     * Difficulties to filter pieces
     */
    'difficulties'?: Array<number>;
    /**
     * Instrumentation Type to filter pieces
     */
    'instrumentationType'?: PieceFilterDTOInstrumentationTypeEnum;
    /**
     * Countries to filter pieces by their composers
     */
    'composerCountries'?: Array<PieceFilterDTOComposerCountriesEnum>;
}

export const PieceFilterDTOOrderOptionEnum = {
    Alphabetical: 'ALPHABETICAL',
    Likes: 'LIKES',
    MostRecent: 'MOST_RECENT'
} as const;

export type PieceFilterDTOOrderOptionEnum = typeof PieceFilterDTOOrderOptionEnum[keyof typeof PieceFilterDTOOrderOptionEnum];
export const PieceFilterDTOInstrumentationTypeEnum = {
    Solo: 'SOLO',
    Orchestra: 'ORCHESTRA',
    ChamberMusic: 'CHAMBER_MUSIC'
} as const;

export type PieceFilterDTOInstrumentationTypeEnum = typeof PieceFilterDTOInstrumentationTypeEnum[keyof typeof PieceFilterDTOInstrumentationTypeEnum];
export const PieceFilterDTOComposerCountriesEnum = {
    NoSelection: 'NO_SELECTION',
    Afghanistan: 'AFGHANISTAN',
    Albania: 'ALBANIA',
    Algeria: 'ALGERIA',
    Andorra: 'ANDORRA',
    Angola: 'ANGOLA',
    AntiguaAndBarbuda: 'ANTIGUA_AND_BARBUDA',
    Argentina: 'ARGENTINA',
    Armenia: 'ARMENIA',
    Australia: 'AUSTRALIA',
    Austria: 'AUSTRIA',
    Azerbaijan: 'AZERBAIJAN',
    Bahamas: 'BAHAMAS',
    Bahrain: 'BAHRAIN',
    Bangladesh: 'BANGLADESH',
    Barbados: 'BARBADOS',
    Belarus: 'BELARUS',
    Belgium: 'BELGIUM',
    Belize: 'BELIZE',
    Benin: 'BENIN',
    Bhutan: 'BHUTAN',
    Bolivia: 'BOLIVIA',
    BosniaAndHerzegovina: 'BOSNIA_AND_HERZEGOVINA',
    Botswana: 'BOTSWANA',
    Brazil: 'BRAZIL',
    Brunei: 'BRUNEI',
    Bulgaria: 'BULGARIA',
    BurkinaFaso: 'BURKINA_FASO',
    Burundi: 'BURUNDI',
    CaboVerde: 'CABO_VERDE',
    Cambodia: 'CAMBODIA',
    Cameroon: 'CAMEROON',
    Canada: 'CANADA',
    CentralAfricanRepublic: 'CENTRAL_AFRICAN_REPUBLIC',
    Chad: 'CHAD',
    Chile: 'CHILE',
    China: 'CHINA',
    Colombia: 'COLOMBIA',
    Comoros: 'COMOROS',
    CongoBrazzaville: 'CONGO_BRAZZAVILLE',
    CongoKinshasa: 'CONGO_KINSHASA',
    CostaRica: 'COSTA_RICA',
    Croatia: 'CROATIA',
    Cuba: 'CUBA',
    Cyprus: 'CYPRUS',
    CzechRepublic: 'CZECH_REPUBLIC',
    Denmark: 'DENMARK',
    Djibouti: 'DJIBOUTI',
    Dominica: 'DOMINICA',
    DominicanRepublic: 'DOMINICAN_REPUBLIC',
    Ecuador: 'ECUADOR',
    Egypt: 'EGYPT',
    ElSalvador: 'EL_SALVADOR',
    EquatorialGuinea: 'EQUATORIAL_GUINEA',
    Eritrea: 'ERITREA',
    Estonia: 'ESTONIA',
    Eswatini: 'ESWATINI',
    Ethiopia: 'ETHIOPIA',
    Fiji: 'FIJI',
    Finland: 'FINLAND',
    France: 'FRANCE',
    Gabon: 'GABON',
    Gambia: 'GAMBIA',
    Georgia: 'GEORGIA',
    Germany: 'GERMANY',
    Ghana: 'GHANA',
    Greece: 'GREECE',
    Grenada: 'GRENADA',
    Guatemala: 'GUATEMALA',
    Guinea: 'GUINEA',
    GuineaBissau: 'GUINEA_BISSAU',
    Guyana: 'GUYANA',
    Haiti: 'HAITI',
    Honduras: 'HONDURAS',
    Hungary: 'HUNGARY',
    Iceland: 'ICELAND',
    India: 'INDIA',
    Indonesia: 'INDONESIA',
    Iran: 'IRAN',
    Iraq: 'IRAQ',
    Ireland: 'IRELAND',
    Israel: 'ISRAEL',
    Italy: 'ITALY',
    IvoryCoast: 'IVORY_COAST',
    Jamaica: 'JAMAICA',
    Japan: 'JAPAN',
    Jordan: 'JORDAN',
    Kazakhstan: 'KAZAKHSTAN',
    Kenya: 'KENYA',
    Kiribati: 'KIRIBATI',
    Kosovo: 'KOSOVO',
    Kuwait: 'KUWAIT',
    Kyrgyzstan: 'KYRGYZSTAN',
    Laos: 'LAOS',
    Latvia: 'LATVIA',
    Lebanon: 'LEBANON',
    Lesotho: 'LESOTHO',
    Liberia: 'LIBERIA',
    Libya: 'LIBYA',
    Liechtenstein: 'LIECHTENSTEIN',
    Lithuania: 'LITHUANIA',
    Luxembourg: 'LUXEMBOURG',
    Madagascar: 'MADAGASCAR',
    Malawi: 'MALAWI',
    Malaysia: 'MALAYSIA',
    Maldives: 'MALDIVES',
    Mali: 'MALI',
    Malta: 'MALTA',
    MarshallIslands: 'MARSHALL_ISLANDS',
    Mauritania: 'MAURITANIA',
    Mauritius: 'MAURITIUS',
    Mexico: 'MEXICO',
    Micronesia: 'MICRONESIA',
    Moldova: 'MOLDOVA',
    Monaco: 'MONACO',
    Mongolia: 'MONGOLIA',
    Montenegro: 'MONTENEGRO',
    Morocco: 'MOROCCO',
    Mozambique: 'MOZAMBIQUE',
    Myanmar: 'MYANMAR',
    Namibia: 'NAMIBIA',
    Nauru: 'NAURU',
    Nepal: 'NEPAL',
    Netherlands: 'NETHERLANDS',
    NewZealand: 'NEW_ZEALAND',
    Nicaragua: 'NICARAGUA',
    Niger: 'NIGER',
    Nigeria: 'NIGERIA',
    NorthKorea: 'NORTH_KOREA',
    NorthMacedonia: 'NORTH_MACEDONIA',
    Norway: 'NORWAY',
    Oman: 'OMAN',
    Pakistan: 'PAKISTAN',
    Palau: 'PALAU',
    Palestine: 'PALESTINE',
    Panama: 'PANAMA',
    PapuaNewGuinea: 'PAPUA_NEW_GUINEA',
    Paraguay: 'PARAGUAY',
    Peru: 'PERU',
    Philippines: 'PHILIPPINES',
    Poland: 'POLAND',
    Portugal: 'PORTUGAL',
    Qatar: 'QATAR',
    Romania: 'ROMANIA',
    Russia: 'RUSSIA',
    Rwanda: 'RWANDA',
    SaintKittsAndNevis: 'SAINT_KITTS_AND_NEVIS',
    SaintLucia: 'SAINT_LUCIA',
    SaintVincentAndTheGrenadines: 'SAINT_VINCENT_AND_THE_GRENADINES',
    Samoa: 'SAMOA',
    SanMarino: 'SAN_MARINO',
    SaoTomeAndPrincipe: 'SAO_TOME_AND_PRINCIPE',
    SaudiArabia: 'SAUDI_ARABIA',
    Senegal: 'SENEGAL',
    Serbia: 'SERBIA',
    Seychelles: 'SEYCHELLES',
    SierraLeone: 'SIERRA_LEONE',
    Singapore: 'SINGAPORE',
    Slovakia: 'SLOVAKIA',
    Slovenia: 'SLOVENIA',
    SolomonIslands: 'SOLOMON_ISLANDS',
    Somalia: 'SOMALIA',
    SouthAfrica: 'SOUTH_AFRICA',
    SouthKorea: 'SOUTH_KOREA',
    SouthSudan: 'SOUTH_SUDAN',
    Spain: 'SPAIN',
    SriLanka: 'SRI_LANKA',
    Sudan: 'SUDAN',
    Suriname: 'SURINAME',
    Sweden: 'SWEDEN',
    Switzerland: 'SWITZERLAND',
    Syria: 'SYRIA',
    Taiwan: 'TAIWAN',
    Tajikistan: 'TAJIKISTAN',
    Tanzania: 'TANZANIA',
    Thailand: 'THAILAND',
    TimorLeste: 'TIMOR_LESTE',
    Togo: 'TOGO',
    Tonga: 'TONGA',
    TrinidadAndTobago: 'TRINIDAD_AND_TOBAGO',
    Tunisia: 'TUNISIA',
    Turkey: 'TURKEY',
    Turkmenistan: 'TURKMENISTAN',
    Tuvalu: 'TUVALU',
    Uganda: 'UGANDA',
    Ukraine: 'UKRAINE',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    UnitedKingdom: 'UNITED_KINGDOM',
    UnitedStates: 'UNITED_STATES',
    Uruguay: 'URUGUAY',
    Uzbekistan: 'UZBEKISTAN',
    Vanuatu: 'VANUATU',
    VaticanCity: 'VATICAN_CITY',
    Venezuela: 'VENEZUELA',
    Vietnam: 'VIETNAM',
    Yemen: 'YEMEN',
    Zambia: 'ZAMBIA',
    Zimbabwe: 'ZIMBABWE'
} as const;

export type PieceFilterDTOComposerCountriesEnum = typeof PieceFilterDTOComposerCountriesEnum[keyof typeof PieceFilterDTOComposerCountriesEnum];

export interface PieceFilterResultDTO {
    /**
     * The pieces matching the filter criteria
     */
    'pieces': Array<PieceResponseDTOSimple>;
    /**
     * THe current page number
     */
    'page': number;
    /**
     * The total number of pages available
     */
    'pagesAvailable': number;
    /**
     * The total number of pieces matching the filter criteria
     */
    'totalAmount': number;
    /**
     * The maximum duration that can be found under the current filter criteria
     */
    'maxPossibleDuration': number;
    /**
     * The maximum price that can be found under the current filter criteria
     */
    'maxPossiblePrice': number;
    /**
     * All the instruments with amount that exist under the current filter criteria
     */
    'instrumentsWithAmount': Array<InstrumentAmountDTO>;
    /**
     * All the keywords that exist under the current filter criteria
     */
    'keywords': Array<string>;
    /**
     * All the countries that a composer of a piece matching the filter criteria is from
     */
    'countries': Array<CountryAmountDTO>;
}
export interface PieceResponseDTO {
    /**
     * The id of the piece
     */
    'id': number;
    /**
     * The title of the piece
     */
    'title': string;
    /**
     * The Description of the piece
     */
    'description': string;
    /**
     * The Composer
     */
    'composer': ArtistResponseDTOMin;
    /**
     * The price of the piece
     */
    'price': number;
    /**
     * The year the piece was written in
     */
    'year': number;
    /**
     * The difficulty of the piece
     */
    'difficulty': number;
    /**
     * The duration of the piece
     */
    'duration': number;
    /**
     * If the piece is an original composition or a transcription
     */
    'original': boolean;
    /**
     * If the piece is blocked
     */
    'blocked': boolean;
    /**
     * If the piece is confirmed
     */
    'confirmed': boolean;
    /**
     * If the piece is unlisted
     */
    'unlisted': boolean;
    /**
     * The pieces performances
     */
    'performances': Array<PerformanceResponseDTO>;
    /**
     * The pieces contributors
     */
    'contributors': Array<ContributorResponseDTO>;
    /**
     * The pieces scores
     */
    'scores': Array<ScoreResponseDTO>;
    /**
     * External Score Link
     */
    'externalScoreLink'?: string;
    /**
     * The pieces keywords
     */
    'keywords': Set<string>;
    /**
     * The pieces transcription info
     */
    'transcriptionInfo': TranscriptionInfoResponseDTO;
    /**
     * The pieces upload date
     */
    'uploadDate': string;
    /**
     * The pieces version
     */
    'version': number;
    /**
     * The preview hash of the piece\'s preview
     */
    'previewHash': string;
    /**
     * The preview page count of the piece\'s preview
     */
    'previewPageCount'?: number;
    /**
     * The thumbnail hash of the piece\'s thumbnail
     */
    'thumbnailHash': string;
    /**
     * If the piece has a custom thumbnail
     */
    'customThumbnail': boolean;
    /**
     * The pieces instruments
     */
    'instruments': Array<InstrumentAmountDTO>;
    /**
     * The pieces orchestral instruments
     */
    'orchestralInstruments'?: Array<InstrumentAmountDTO>;
    /**
     * The amount of likes the piece has
     */
    'likes': number;
    /**
     * The amount of downloads the piece has
     */
    'downloads': number;
    /**
     * The average score the piece has compared with other pieces
     */
    'avgCompareScore': number;
    /**
     * The amount of views the piece has
     */
    'views': number;
    /**
     * The amount of views the piece has
     */
    'pages': number;
    /**
     * If the current user has liked the piece
     */
    'hasLiked': boolean;
    /**
     * If the current user has access to the piece
     */
    'hasAccess': boolean;
    /**
     * If the current user has bookmarked to the piece
     */
    'hasBookmarked': boolean;
    /**
     * If the current user can download to the piece
     */
    'canDownload': boolean;
    /**
     * The page number from which the thumbnail is generated
     */
    'generateThumbnailFromPage': number;
    /**
     * The movements of the piece
     */
    'movements'?: Array<string>;
    'free'?: boolean;
}
export interface PieceResponseDTOAdmin {
    /**
     * The title of the piece
     */
    'title': string;
    /**
     * If the piece is confirmed
     */
    'confirmed': boolean;
    /**
     * If the piece is unlisted
     */
    'unlisted': boolean;
    /**
     * The confirmed message for the piece (if any)
     */
    'confirmedMessage'?: string;
    /**
     * The amount of likes the piece has
     */
    'likes': number;
    /**
     * The amount of downloads the piece has
     */
    'downloads': number;
    /**
     * The amount of sales the piece has
     */
    'sales': number;
    /**
     * The revenue earned from the piece
     */
    'earnedMoney': number;
}
export interface PieceResponseDTOMin {
    /**
     * The id of the piece
     */
    'id': number;
    /**
     * The title of the piece
     */
    'title': string;
    /**
     * The name of the piece\'s author
     */
    'author': string;
    /**
     * If the piece is confirmed
     */
    'confirmed': boolean;
    /**
     * The hash of the piece\'s thumbnail image
     */
    'thumbnailHash': string;
}
export interface PieceResponseDTOOwn {
    /**
     * The title of the piece
     */
    'title': string;
    /**
     * If the piece is confirmed
     */
    'confirmed': boolean;
    /**
     * If the piece is unlisted
     */
    'unlisted': boolean;
    /**
     * The confirmed message for the piece (if any)
     */
    'confirmedMessage'?: string;
    /**
     * The amount of likes the piece has
     */
    'likes': number;
    /**
     * The amount of downloads the piece has
     */
    'downloads': number;
    /**
     * The amount of sales the piece has
     */
    'sales': number;
    /**
     * The revenue earned from the piece
     */
    'earnedMoney': number;
}
export interface PieceResponseDTOSimple {
    /**
     * The id of the piece
     */
    'id': number;
    /**
     * The title of the piece
     */
    'title': string;
    /**
     * If the piece is confirmed
     */
    'confirmed': boolean;
    /**
     * The price of the piece
     */
    'price': number;
    /**
     * The year the piece was written in
     */
    'year': number;
    /**
     * The difficulty of the piece
     */
    'difficulty': number;
    /**
     * If the piece is an original composition or a transcription
     */
    'original': boolean;
    /**
     * The duration of the piece
     */
    'duration': number;
    /**
     * The pieces upload date
     */
    'uploadDate': string;
    /**
     * The pieces instruments
     */
    'instruments': Array<InstrumentAmountDTO>;
    /**
     * The pieces orchestral instruments
     */
    'orchestralInstruments'?: Array<InstrumentAmountDTO>;
    /**
     * The thumbnail hash of the piece\'s thumbnail
     */
    'thumbnailHash': string;
    /**
     * If the piece is linked to an external source
     */
    'externalPiece': boolean;
    /**
     * The name of the piece\'s author
     */
    'author': string;
    /**
     * The real composer of the piece (in case of a transcription)
     */
    'realComposer': string;
    /**
     * The amount of likes the piece has
     */
    'likes': number;
    /**
     * The amount of downloads the piece has
     */
    'downloads': number;
}
export interface PurchaseAccountCreditCommitDto {
    'amount'?: number;
}
export interface PurchaseCommitDto {
    'useBalance'?: boolean;
}
export interface PurchaseInfoResponseDTO {
    /**
     * The title of the piece being purchased
     */
    'title': string;
    /**
     * The account balance available to use for this purchase
     */
    'balance': number;
    /**
     * The original price of the item
     */
    'price': number;
    /**
     * The reduced price after applying account balance
     */
    'priceReduced': number;
}
export interface PurchaseResponseDTO {
    /**
     * Purchase id
     */
    'id': number;
    /**
     * The price payed
     */
    'price': number;
    /**
     * The transaction fees
     */
    'transactionFees': number;
    /**
     * Whether balance was used
     */
    'usedBalance': boolean;
    /**
     * Date of purchase
     */
    'date': string;
    /**
     * Account name of purchaser
     */
    'accountName': string;
    /**
     * Composer name
     */
    'composerName': string;
    /**
     * Piece name
     */
    'pieceName': string;
    /**
     * Account id of purchaser
     */
    'accountId': number;
    /**
     * Composer id
     */
    'composerId': number;
    /**
     * Piece id
     */
    'pieceId': number;
}
export interface RecentPayoutResponseDTO {
    /**
     * Users balance
     */
    'balance': number;
    /**
     * Last payout request details
     */
    'lastPayout': PayoutResponseDTO;
    /**
     * Name of the account holder
     */
    'name': string;
}
export interface RegisterDto {
    /**
     * The email of the new account
     */
    'email': string;
    /**
     * The password of the new account
     */
    'password': string;
}
export interface ReportDTO {
    /**
     * The id of the piece that is being reported
     */
    'pieceId': number;
    /**
     * The reason for reporting the piece
     */
    'reason': string;
}
export interface ScoreResponseDTO {
    /**
     * The id of the score
     */
    'id': number;
    /**
     * The name of the score
     */
    'name': string;
    /**
     * The hash of the score file
     */
    'fileHash': string;
}
export interface ScoreUpdateDTO {
    /**
     * The id of the score
     */
    'id'?: number;
    /**
     * Name of the score
     */
    'name': string;
    /**
     * The id of the asset associated with the score
     */
    'fileHash'?: string;
}
export interface SettingsResponseDTO {
    /**
     * The accounts email
     */
    'email': string;
    /**
     * If notifications are enabled
     */
    'notifications': boolean;
    /**
     * The last password change date
     */
    'lastPasswordChange': string;
}
export interface StripeCheckoutResponseDTO {
    /**
     * The status of the checkout session
     */
    'status': string;
    /**
     * A message providing additional information about the checkout session
     */
    'message': string;
    /**
     * The ID of the checkout session
     */
    'sessionId': string;
    /**
     * The URL to complete the checkout session
     */
    'sessionUrl': string;
}
export interface TranscriptionInfoDTO {
    /**
     * The artist ID of the contributor
     */
    'artistId': number;
    /**
     * The name of the contributor. If artist Id empty
     */
    'name': string;
    /**
     * The real year of the transcription
     */
    'realYear': number;
}
export interface TranscriptionInfoResponseDTO {
    /**
     * The original composer of the transcription
     */
    'originalComposer': ArtistResponseDTOMin;
    /**
     * The real year of the transcription
     */
    'realYear': number;
    /**
     * The artist ID of the contributor
     */
    'artistId': number;
    /**
     * The name of the contributor. If artist Id empty
     */
    'name': string;
}
export interface UpdateArtistProfileRequest {
    'profilePicture'?: File;
    'artistDTO': ArtistDTO;
}
export interface UpdateEmailDto {
    /**
     * The new email address
     */
    'email': string;
}
export interface UpdatePasswordDto {
    'oldPassword'?: string;
    'newPassword'?: string;
}
export interface UploadPreviewRequest {
    'scoreFile'?: File;
}
export interface UploadRequest {
    'scoreFile'?: File;
    'scoreUpdateDTO': ScoreUpdateDTO;
}
export interface VerifyEmailDto {
    'code'?: number;
}
export interface VerifyEmailResponseDTO {
    /**
     * The verified email address
     */
    'email': string;
    /**
     * The accounts id
     */
    'accountId'?: number;
    /**
     * Time to wait in seconds before a new verification email can be sent
     */
    'timeToWait'?: number;
}

/**
 * AccountControllerApi - axios parameter creator
 */
export const AccountControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {AccountConfirmedDto} accountConfirmedDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        block: async (authorization: string, accountConfirmedDto: AccountConfirmedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('block', 'authorization', authorization)
            // verify required parameter 'accountConfirmedDto' is not null or undefined
            assertParamExists('block', 'accountConfirmedDto', accountConfirmedDto)
            const localVarPath = `/account/admin/block`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accountConfirmedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        check: async (authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('check', 'authorization', authorization)
            const localVarPath = `/account/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {AccountConfirmedDto} accountConfirmedDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirm1: async (authorization: string, accountConfirmedDto: AccountConfirmedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('confirm1', 'authorization', authorization)
            // verify required parameter 'accountConfirmedDto' is not null or undefined
            assertParamExists('confirm1', 'accountConfirmedDto', accountConfirmedDto)
            const localVarPath = `/account/admin/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accountConfirmedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {number} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount: async (authorization: string, accountId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getAccount', 'authorization', authorization)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getAccount', 'accountId', accountId)
            const localVarPath = `/account/admin/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAccounts: async (authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getAllAccounts', 'authorization', authorization)
            const localVarPath = `/account/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoginDTO} loginDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginDTO: LoginDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginDTO' is not null or undefined
            assertParamExists('login', 'loginDTO', loginDTO)
            const localVarPath = `/account/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('logout', 'authorization', authorization)
            const localVarPath = `/account/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegisterDto} registerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (registerDto: RegisterDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerDto' is not null or undefined
            assertParamExists('register', 'registerDto', registerDto)
            const localVarPath = `/account/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {AccountEmailDto} accountEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUpdateEmail: async (id: number, accountEmailDto: AccountEmailDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('registerUpdateEmail', 'id', id)
            // verify required parameter 'accountEmailDto' is not null or undefined
            assertParamExists('registerUpdateEmail', 'accountEmailDto', accountEmailDto)
            const localVarPath = `/account/register/updateEmail/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accountEmailDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendVerificationMail: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sendVerificationMail', 'id', id)
            const localVarPath = `/account/verify/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AccountEmailDto} accountEmailDto 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmail: async (accountEmailDto: AccountEmailDto, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountEmailDto' is not null or undefined
            assertParamExists('updateEmail', 'accountEmailDto', accountEmailDto)
            const localVarPath = `/account/update/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accountEmailDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {VerifyEmailDto} verifyEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmail: async (id: number, verifyEmailDto: VerifyEmailDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('verifyEmail', 'id', id)
            // verify required parameter 'verifyEmailDto' is not null or undefined
            assertParamExists('verifyEmail', 'verifyEmailDto', verifyEmailDto)
            const localVarPath = `/account/verify/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyEmailDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountControllerApi - functional programming interface
 */
export const AccountControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {AccountConfirmedDto} accountConfirmedDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async block(authorization: string, accountConfirmedDto: AccountConfirmedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.block(authorization, accountConfirmedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountControllerApi.block']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async check(authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.check(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountControllerApi.check']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {AccountConfirmedDto} accountConfirmedDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirm1(authorization: string, accountConfirmedDto: AccountConfirmedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirm1(authorization, accountConfirmedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountControllerApi.confirm1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {number} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccount(authorization: string, accountId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountAdminResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccount(authorization, accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountControllerApi.getAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAccounts(authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccountAdminResponseDTOMin>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAccounts(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountControllerApi.getAllAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LoginDTO} loginDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginDTO: LoginDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountControllerApi.login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountControllerApi.logout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RegisterDto} registerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(registerDto: RegisterDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(registerDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountControllerApi.register']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {AccountEmailDto} accountEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerUpdateEmail(id: number, accountEmailDto: AccountEmailDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerUpdateEmail(id, accountEmailDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountControllerApi.registerUpdateEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendVerificationMail(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyEmailResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendVerificationMail(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountControllerApi.sendVerificationMail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AccountEmailDto} accountEmailDto 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmail(accountEmailDto: AccountEmailDto, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmail(accountEmailDto, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountControllerApi.updateEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {VerifyEmailDto} verifyEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyEmail(id: number, verifyEmailDto: VerifyEmailDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyEmail(id, verifyEmailDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountControllerApi.verifyEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AccountControllerApi - factory interface
 */
export const AccountControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {AccountConfirmedDto} accountConfirmedDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        block(authorization: string, accountConfirmedDto: AccountConfirmedDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.block(authorization, accountConfirmedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        check(authorization: string, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDTO> {
            return localVarFp.check(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {AccountConfirmedDto} accountConfirmedDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirm1(authorization: string, accountConfirmedDto: AccountConfirmedDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.confirm1(authorization, accountConfirmedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {number} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount(authorization: string, accountId: number, options?: RawAxiosRequestConfig): AxiosPromise<AccountAdminResponseDTO> {
            return localVarFp.getAccount(authorization, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAccounts(authorization: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AccountAdminResponseDTOMin>> {
            return localVarFp.getAllAccounts(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LoginDTO} loginDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginDTO: LoginDTO, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDTO> {
            return localVarFp.login(loginDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(authorization: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.logout(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RegisterDto} registerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(registerDto: RegisterDto, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.register(registerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {AccountEmailDto} accountEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUpdateEmail(id: number, accountEmailDto: AccountEmailDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.registerUpdateEmail(id, accountEmailDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendVerificationMail(id: number, options?: RawAxiosRequestConfig): AxiosPromise<VerifyEmailResponseDTO> {
            return localVarFp.sendVerificationMail(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountEmailDto} accountEmailDto 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmail(accountEmailDto: AccountEmailDto, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateEmail(accountEmailDto, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {VerifyEmailDto} verifyEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmail(id: number, verifyEmailDto: VerifyEmailDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.verifyEmail(id, verifyEmailDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountControllerApi - object-oriented interface
 */
export class AccountControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} authorization 
     * @param {AccountConfirmedDto} accountConfirmedDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public block(authorization: string, accountConfirmedDto: AccountConfirmedDto, options?: RawAxiosRequestConfig) {
        return AccountControllerApiFp(this.configuration).block(authorization, accountConfirmedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public check(authorization: string, options?: RawAxiosRequestConfig) {
        return AccountControllerApiFp(this.configuration).check(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {AccountConfirmedDto} accountConfirmedDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public confirm1(authorization: string, accountConfirmedDto: AccountConfirmedDto, options?: RawAxiosRequestConfig) {
        return AccountControllerApiFp(this.configuration).confirm1(authorization, accountConfirmedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {number} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAccount(authorization: string, accountId: number, options?: RawAxiosRequestConfig) {
        return AccountControllerApiFp(this.configuration).getAccount(authorization, accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllAccounts(authorization: string, options?: RawAxiosRequestConfig) {
        return AccountControllerApiFp(this.configuration).getAllAccounts(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LoginDTO} loginDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public login(loginDTO: LoginDTO, options?: RawAxiosRequestConfig) {
        return AccountControllerApiFp(this.configuration).login(loginDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public logout(authorization: string, options?: RawAxiosRequestConfig) {
        return AccountControllerApiFp(this.configuration).logout(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RegisterDto} registerDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public register(registerDto: RegisterDto, options?: RawAxiosRequestConfig) {
        return AccountControllerApiFp(this.configuration).register(registerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {AccountEmailDto} accountEmailDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public registerUpdateEmail(id: number, accountEmailDto: AccountEmailDto, options?: RawAxiosRequestConfig) {
        return AccountControllerApiFp(this.configuration).registerUpdateEmail(id, accountEmailDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendVerificationMail(id: number, options?: RawAxiosRequestConfig) {
        return AccountControllerApiFp(this.configuration).sendVerificationMail(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountEmailDto} accountEmailDto 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateEmail(accountEmailDto: AccountEmailDto, authorization?: string, options?: RawAxiosRequestConfig) {
        return AccountControllerApiFp(this.configuration).updateEmail(accountEmailDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {VerifyEmailDto} verifyEmailDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public verifyEmail(id: number, verifyEmailDto: VerifyEmailDto, options?: RawAxiosRequestConfig) {
        return AccountControllerApiFp(this.configuration).verifyEmail(id, verifyEmailDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ArtistControllerApi - axios parameter creator
 */
export const ArtistControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {UpdateArtistProfileRequest} [updateArtistProfileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createArtistProfile: async (authorization: string, updateArtistProfileRequest?: UpdateArtistProfileRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createArtistProfile', 'authorization', authorization)
            const localVarPath = `/artists/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateArtistProfileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteArtist: async (id: number, authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteArtist', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteArtist', 'authorization', authorization)
            const localVarPath = `/artists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {UpdateArtistProfileRequest} [updateArtistProfileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editArtistProfile: async (id: number, authorization: string, updateArtistProfileRequest?: UpdateArtistProfileRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('editArtistProfile', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('editArtistProfile', 'authorization', authorization)
            const localVarPath = `/artists/admin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateArtistProfileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FindArtistDTO} findArtistDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findArtist: async (findArtistDTO: FindArtistDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'findArtistDTO' is not null or undefined
            assertParamExists('findArtist', 'findArtistDTO', findArtistDTO)
            const localVarPath = `/artists/find`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findArtistDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllArtists: async (authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getAllArtists', 'authorization', authorization)
            const localVarPath = `/artists/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtist: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getArtist', 'id', id)
            const localVarPath = `/artists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtistAdmin: async (id: number, authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getArtistAdmin', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getArtistAdmin', 'authorization', authorization)
            const localVarPath = `/artists/admin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtistProfile: async (id: number, authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getArtistProfile', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getArtistProfile', 'authorization', authorization)
            const localVarPath = `/artists/admin/profile/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtists: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtistsAlsoContributors: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artists/alsoContributors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnArtistProfile: async (authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getOwnArtistProfile', 'authorization', authorization)
            const localVarPath = `/artists/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {UpdateArtistProfileRequest} [updateArtistProfileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArtistProfile: async (authorization: string, updateArtistProfileRequest?: UpdateArtistProfileRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateArtistProfile', 'authorization', authorization)
            const localVarPath = `/artists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateArtistProfileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArtistControllerApi - functional programming interface
 */
export const ArtistControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ArtistControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {UpdateArtistProfileRequest} [updateArtistProfileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createArtistProfile(authorization: string, updateArtistProfileRequest?: UpdateArtistProfileRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArtistResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createArtistProfile(authorization, updateArtistProfileRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtistControllerApi.createArtistProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteArtist(id: number, authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteArtist(id, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtistControllerApi.deleteArtist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {UpdateArtistProfileRequest} [updateArtistProfileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editArtistProfile(id: number, authorization: string, updateArtistProfileRequest?: UpdateArtistProfileRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArtistResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editArtistProfile(id, authorization, updateArtistProfileRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtistControllerApi.editArtistProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {FindArtistDTO} findArtistDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findArtist(findArtistDTO: FindArtistDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ArtistResponseDTOMin>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findArtist(findArtistDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtistControllerApi.findArtist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllArtists(authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ArtistResponseDTOMin>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllArtists(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtistControllerApi.getAllArtists']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArtist(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArtistResponseDTOFull>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArtist(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtistControllerApi.getArtist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArtistAdmin(id: number, authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArtistAdminResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArtistAdmin(id, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtistControllerApi.getArtistAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArtistProfile(id: number, authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArtistResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArtistProfile(id, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtistControllerApi.getArtistProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArtists(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ArtistResponseDTOMin>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArtists(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtistControllerApi.getArtists']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArtistsAlsoContributors(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ArtistResponseDTOMin>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArtistsAlsoContributors(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtistControllerApi.getArtistsAlsoContributors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOwnArtistProfile(authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArtistResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOwnArtistProfile(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtistControllerApi.getOwnArtistProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {UpdateArtistProfileRequest} [updateArtistProfileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateArtistProfile(authorization: string, updateArtistProfileRequest?: UpdateArtistProfileRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArtistResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateArtistProfile(authorization, updateArtistProfileRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtistControllerApi.updateArtistProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ArtistControllerApi - factory interface
 */
export const ArtistControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ArtistControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {UpdateArtistProfileRequest} [updateArtistProfileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createArtistProfile(authorization: string, updateArtistProfileRequest?: UpdateArtistProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<ArtistResponseDTO> {
            return localVarFp.createArtistProfile(authorization, updateArtistProfileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteArtist(id: number, authorization: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteArtist(id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {UpdateArtistProfileRequest} [updateArtistProfileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editArtistProfile(id: number, authorization: string, updateArtistProfileRequest?: UpdateArtistProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<ArtistResponseDTO> {
            return localVarFp.editArtistProfile(id, authorization, updateArtistProfileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FindArtistDTO} findArtistDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findArtist(findArtistDTO: FindArtistDTO, options?: RawAxiosRequestConfig): AxiosPromise<Array<ArtistResponseDTOMin>> {
            return localVarFp.findArtist(findArtistDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllArtists(authorization: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ArtistResponseDTOMin>> {
            return localVarFp.getAllArtists(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtist(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ArtistResponseDTOFull> {
            return localVarFp.getArtist(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtistAdmin(id: number, authorization: string, options?: RawAxiosRequestConfig): AxiosPromise<ArtistAdminResponseDTO> {
            return localVarFp.getArtistAdmin(id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtistProfile(id: number, authorization: string, options?: RawAxiosRequestConfig): AxiosPromise<ArtistResponseDTO> {
            return localVarFp.getArtistProfile(id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtists(options?: RawAxiosRequestConfig): AxiosPromise<Array<ArtistResponseDTOMin>> {
            return localVarFp.getArtists(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtistsAlsoContributors(options?: RawAxiosRequestConfig): AxiosPromise<Array<ArtistResponseDTOMin>> {
            return localVarFp.getArtistsAlsoContributors(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnArtistProfile(authorization: string, options?: RawAxiosRequestConfig): AxiosPromise<ArtistResponseDTO> {
            return localVarFp.getOwnArtistProfile(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {UpdateArtistProfileRequest} [updateArtistProfileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArtistProfile(authorization: string, updateArtistProfileRequest?: UpdateArtistProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<ArtistResponseDTO> {
            return localVarFp.updateArtistProfile(authorization, updateArtistProfileRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ArtistControllerApi - object-oriented interface
 */
export class ArtistControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} authorization 
     * @param {UpdateArtistProfileRequest} [updateArtistProfileRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createArtistProfile(authorization: string, updateArtistProfileRequest?: UpdateArtistProfileRequest, options?: RawAxiosRequestConfig) {
        return ArtistControllerApiFp(this.configuration).createArtistProfile(authorization, updateArtistProfileRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteArtist(id: number, authorization: string, options?: RawAxiosRequestConfig) {
        return ArtistControllerApiFp(this.configuration).deleteArtist(id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} authorization 
     * @param {UpdateArtistProfileRequest} [updateArtistProfileRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public editArtistProfile(id: number, authorization: string, updateArtistProfileRequest?: UpdateArtistProfileRequest, options?: RawAxiosRequestConfig) {
        return ArtistControllerApiFp(this.configuration).editArtistProfile(id, authorization, updateArtistProfileRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FindArtistDTO} findArtistDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findArtist(findArtistDTO: FindArtistDTO, options?: RawAxiosRequestConfig) {
        return ArtistControllerApiFp(this.configuration).findArtist(findArtistDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllArtists(authorization: string, options?: RawAxiosRequestConfig) {
        return ArtistControllerApiFp(this.configuration).getAllArtists(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getArtist(id: number, options?: RawAxiosRequestConfig) {
        return ArtistControllerApiFp(this.configuration).getArtist(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getArtistAdmin(id: number, authorization: string, options?: RawAxiosRequestConfig) {
        return ArtistControllerApiFp(this.configuration).getArtistAdmin(id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getArtistProfile(id: number, authorization: string, options?: RawAxiosRequestConfig) {
        return ArtistControllerApiFp(this.configuration).getArtistProfile(id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getArtists(options?: RawAxiosRequestConfig) {
        return ArtistControllerApiFp(this.configuration).getArtists(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getArtistsAlsoContributors(options?: RawAxiosRequestConfig) {
        return ArtistControllerApiFp(this.configuration).getArtistsAlsoContributors(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOwnArtistProfile(authorization: string, options?: RawAxiosRequestConfig) {
        return ArtistControllerApiFp(this.configuration).getOwnArtistProfile(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {UpdateArtistProfileRequest} [updateArtistProfileRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateArtistProfile(authorization: string, updateArtistProfileRequest?: UpdateArtistProfileRequest, options?: RawAxiosRequestConfig) {
        return ArtistControllerApiFp(this.configuration).updateArtistProfile(authorization, updateArtistProfileRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AssetControllerApi - axios parameter creator
 */
export const AssetControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {File} file 
         * @param {AssetCreateDTO} assetCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAsset: async (file: File, assetCreateDTO: AssetCreateDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('createAsset', 'file', file)
            // verify required parameter 'assetCreateDTO' is not null or undefined
            assertParamExists('createAsset', 'assetCreateDTO', assetCreateDTO)
            const localVarPath = `/assets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (assetCreateDTO !== undefined) { 
                localVarFormParams.append('assetCreateDTO', new Blob([JSON.stringify(assetCreateDTO)], { type: "application/json", }));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} hash 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetByHash: async (hash: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hash' is not null or undefined
            assertParamExists('getAssetByHash', 'hash', hash)
            const localVarPath = `/assets/by-hash/{hash}`
                .replace(`{${"hash"}}`, encodeURIComponent(String(hash)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAssetById', 'id', id)
            const localVarPath = `/assets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetData: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAssetData', 'id', id)
            const localVarPath = `/assets/data/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} hash 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetInfoByHash: async (hash: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hash' is not null or undefined
            assertParamExists('getAssetInfoByHash', 'hash', hash)
            const localVarPath = `/assets/by-hash/{hash}/info`
                .replace(`{${"hash"}}`, encodeURIComponent(String(hash)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssetControllerApi - functional programming interface
 */
export const AssetControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssetControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {File} file 
         * @param {AssetCreateDTO} assetCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAsset(file: File, assetCreateDTO: AssetCreateDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAsset(file, assetCreateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetControllerApi.createAsset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} hash 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssetByHash(hash: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssetByHash(hash, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetControllerApi.getAssetByHash']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssetById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetControllerApi.getAssetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssetData(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssetData(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetControllerApi.getAssetData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} hash 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssetInfoByHash(hash: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssetInfoByHash(hash, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetControllerApi.getAssetInfoByHash']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssetControllerApi - factory interface
 */
export const AssetControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssetControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {File} file 
         * @param {AssetCreateDTO} assetCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAsset(file: File, assetCreateDTO: AssetCreateDTO, options?: RawAxiosRequestConfig): AxiosPromise<AssetResponseDTO> {
            return localVarFp.createAsset(file, assetCreateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} hash 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetByHash(hash: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getAssetByHash(hash, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<AssetResponseDTO> {
            return localVarFp.getAssetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetData(id: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getAssetData(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} hash 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetInfoByHash(hash: string, options?: RawAxiosRequestConfig): AxiosPromise<AssetResponseDTO> {
            return localVarFp.getAssetInfoByHash(hash, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssetControllerApi - object-oriented interface
 */
export class AssetControllerApi extends BaseAPI {
    /**
     * 
     * @param {File} file 
     * @param {AssetCreateDTO} assetCreateDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createAsset(file: File, assetCreateDTO: AssetCreateDTO, options?: RawAxiosRequestConfig) {
        return AssetControllerApiFp(this.configuration).createAsset(file, assetCreateDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} hash 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAssetByHash(hash: string, options?: RawAxiosRequestConfig) {
        return AssetControllerApiFp(this.configuration).getAssetByHash(hash, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAssetById(id: number, options?: RawAxiosRequestConfig) {
        return AssetControllerApiFp(this.configuration).getAssetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAssetData(id: number, options?: RawAxiosRequestConfig) {
        return AssetControllerApiFp(this.configuration).getAssetData(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} hash 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAssetInfoByHash(hash: string, options?: RawAxiosRequestConfig) {
        return AssetControllerApiFp(this.configuration).getAssetInfoByHash(hash, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BookmarkControllerApi - axios parameter creator
 */
export const BookmarkControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBookmark: async (authorization: string, id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('addBookmark', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addBookmark', 'id', id)
            const localVarPath = `/bookmark/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookmarkedPieces: async (authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getBookmarkedPieces', 'authorization', authorization)
            const localVarPath = `/bookmark`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeBookmark: async (authorization: string, id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('removeBookmark', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeBookmark', 'id', id)
            const localVarPath = `/bookmark/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BookmarkControllerApi - functional programming interface
 */
export const BookmarkControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BookmarkControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addBookmark(authorization: string, id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addBookmark(authorization, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookmarkControllerApi.addBookmark']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookmarkedPieces(authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PieceResponseDTOMin>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookmarkedPieces(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookmarkControllerApi.getBookmarkedPieces']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeBookmark(authorization: string, id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeBookmark(authorization, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookmarkControllerApi.removeBookmark']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BookmarkControllerApi - factory interface
 */
export const BookmarkControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BookmarkControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBookmark(authorization: string, id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addBookmark(authorization, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookmarkedPieces(authorization: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PieceResponseDTOMin>> {
            return localVarFp.getBookmarkedPieces(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeBookmark(authorization: string, id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeBookmark(authorization, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BookmarkControllerApi - object-oriented interface
 */
export class BookmarkControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} authorization 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addBookmark(authorization: string, id: number, options?: RawAxiosRequestConfig) {
        return BookmarkControllerApiFp(this.configuration).addBookmark(authorization, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBookmarkedPieces(authorization: string, options?: RawAxiosRequestConfig) {
        return BookmarkControllerApiFp(this.configuration).getBookmarkedPieces(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeBookmark(authorization: string, id: number, options?: RawAxiosRequestConfig) {
        return BookmarkControllerApiFp(this.configuration).removeBookmark(authorization, id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DownloadControllerApi - axios parameter creator
 */
export const DownloadControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloads: async (authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getDownloads', 'authorization', authorization)
            const localVarPath = `/downloads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DownloadControllerApi - functional programming interface
 */
export const DownloadControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DownloadControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDownloads(authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DownloadResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDownloads(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DownloadControllerApi.getDownloads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DownloadControllerApi - factory interface
 */
export const DownloadControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DownloadControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloads(authorization: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DownloadResponseDTO>> {
            return localVarFp.getDownloads(authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DownloadControllerApi - object-oriented interface
 */
export class DownloadControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDownloads(authorization: string, options?: RawAxiosRequestConfig) {
        return DownloadControllerApiFp(this.configuration).getDownloads(authorization, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InstrumentControllerApi - axios parameter creator
 */
export const InstrumentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/instrument/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InstrumentGroupDTO} dto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstruments: async (dto: InstrumentGroupDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dto' is not null or undefined
            assertParamExists('getInstruments', 'dto', dto)
            const localVarPath = `/instrument/group/instruments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dto !== undefined) {
                for (const [key, value] of Object.entries(dto)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InstrumentControllerApi - functional programming interface
 */
export const InstrumentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InstrumentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroups(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroups(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InstrumentControllerApi.getGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {InstrumentGroupDTO} dto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInstruments(dto: InstrumentGroupDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInstruments(dto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InstrumentControllerApi.getInstruments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InstrumentControllerApi - factory interface
 */
export const InstrumentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InstrumentControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getGroups(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InstrumentGroupDTO} dto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstruments(dto: InstrumentGroupDTO, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getInstruments(dto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InstrumentControllerApi - object-oriented interface
 */
export class InstrumentControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getGroups(options?: RawAxiosRequestConfig) {
        return InstrumentControllerApiFp(this.configuration).getGroups(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InstrumentGroupDTO} dto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getInstruments(dto: InstrumentGroupDTO, options?: RawAxiosRequestConfig) {
        return InstrumentControllerApiFp(this.configuration).getInstruments(dto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * KeywordControllerApi - axios parameter creator
 */
export const KeywordControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeywords: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/keyword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KeywordControllerApi - functional programming interface
 */
export const KeywordControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KeywordControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKeywords(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKeywords(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KeywordControllerApi.getKeywords']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * KeywordControllerApi - factory interface
 */
export const KeywordControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KeywordControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeywords(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getKeywords(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KeywordControllerApi - object-oriented interface
 */
export class KeywordControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getKeywords(options?: RawAxiosRequestConfig) {
        return KeywordControllerApiFp(this.configuration).getKeywords(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LikeControllerApi - axios parameter creator
 */
export const LikeControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLikedPieces: async (authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getLikedPieces', 'authorization', authorization)
            const localVarPath = `/like`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {number} pieceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleLike: async (authorization: string, pieceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('toggleLike', 'authorization', authorization)
            // verify required parameter 'pieceId' is not null or undefined
            assertParamExists('toggleLike', 'pieceId', pieceId)
            const localVarPath = `/like/{pieceId}`
                .replace(`{${"pieceId"}}`, encodeURIComponent(String(pieceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LikeControllerApi - functional programming interface
 */
export const LikeControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LikeControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLikedPieces(authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PieceResponseDTOMin>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLikedPieces(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LikeControllerApi.getLikedPieces']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {number} pieceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleLike(authorization: string, pieceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleLike(authorization, pieceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LikeControllerApi.toggleLike']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LikeControllerApi - factory interface
 */
export const LikeControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LikeControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLikedPieces(authorization: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PieceResponseDTOMin>> {
            return localVarFp.getLikedPieces(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {number} pieceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleLike(authorization: string, pieceId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.toggleLike(authorization, pieceId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LikeControllerApi - object-oriented interface
 */
export class LikeControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLikedPieces(authorization: string, options?: RawAxiosRequestConfig) {
        return LikeControllerApiFp(this.configuration).getLikedPieces(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {number} pieceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public toggleLike(authorization: string, pieceId: number, options?: RawAxiosRequestConfig) {
        return LikeControllerApiFp(this.configuration).toggleLike(authorization, pieceId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OverviewControllerApi - axios parameter creator
 */
export const OverviewControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOverview: async (authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getOverview', 'authorization', authorization)
            const localVarPath = `/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OverviewControllerApi - functional programming interface
 */
export const OverviewControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OverviewControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOverview(authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OverviewResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOverview(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OverviewControllerApi.getOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OverviewControllerApi - factory interface
 */
export const OverviewControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OverviewControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOverview(authorization: string, options?: RawAxiosRequestConfig): AxiosPromise<OverviewResponseDTO> {
            return localVarFp.getOverview(authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OverviewControllerApi - object-oriented interface
 */
export class OverviewControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOverview(authorization: string, options?: RawAxiosRequestConfig) {
        return OverviewControllerApiFp(this.configuration).getOverview(authorization, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PageControllerApi - axios parameter creator
 */
export const PageControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMainPage: async (authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/page/main`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PageControllerApi - functional programming interface
 */
export const PageControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PageControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMainPage(authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MainPageResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMainPage(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PageControllerApi.getMainPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PageControllerApi - factory interface
 */
export const PageControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PageControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMainPage(authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<MainPageResponseDTO> {
            return localVarFp.getMainPage(authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PageControllerApi - object-oriented interface
 */
export class PageControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMainPage(authorization?: string, options?: RawAxiosRequestConfig) {
        return PageControllerApiFp(this.configuration).getMainPage(authorization, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PayOutControllerApi - axios parameter creator
 */
export const PayOutControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closePayOutRequest: async (authorization: string, id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('closePayOutRequest', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('closePayOutRequest', 'id', id)
            const localVarPath = `/payout/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMostRecentPayOut: async (authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getMostRecentPayOut', 'authorization', authorization)
            const localVarPath = `/payout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayoutRequest: async (authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPayoutRequest', 'authorization', authorization)
            const localVarPath = `/payout/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {PayOutDTO} payOutDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPayOut: async (authorization: string, payOutDTO: PayOutDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('sendPayOut', 'authorization', authorization)
            // verify required parameter 'payOutDTO' is not null or undefined
            assertParamExists('sendPayOut', 'payOutDTO', payOutDTO)
            const localVarPath = `/payout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payOutDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PayOutControllerApi - functional programming interface
 */
export const PayOutControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PayOutControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closePayOutRequest(authorization: string, id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closePayOutRequest(authorization, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayOutControllerApi.closePayOutRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMostRecentPayOut(authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecentPayoutResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMostRecentPayOut(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayOutControllerApi.getMostRecentPayOut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPayoutRequest(authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllPayoutsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPayoutRequest(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayOutControllerApi.getPayoutRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {PayOutDTO} payOutDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendPayOut(authorization: string, payOutDTO: PayOutDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayoutResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendPayOut(authorization, payOutDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayOutControllerApi.sendPayOut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PayOutControllerApi - factory interface
 */
export const PayOutControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PayOutControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closePayOutRequest(authorization: string, id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.closePayOutRequest(authorization, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMostRecentPayOut(authorization: string, options?: RawAxiosRequestConfig): AxiosPromise<RecentPayoutResponseDTO> {
            return localVarFp.getMostRecentPayOut(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayoutRequest(authorization: string, options?: RawAxiosRequestConfig): AxiosPromise<AllPayoutsResponseDTO> {
            return localVarFp.getPayoutRequest(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {PayOutDTO} payOutDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPayOut(authorization: string, payOutDTO: PayOutDTO, options?: RawAxiosRequestConfig): AxiosPromise<PayoutResponseDTO> {
            return localVarFp.sendPayOut(authorization, payOutDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PayOutControllerApi - object-oriented interface
 */
export class PayOutControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} authorization 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public closePayOutRequest(authorization: string, id: number, options?: RawAxiosRequestConfig) {
        return PayOutControllerApiFp(this.configuration).closePayOutRequest(authorization, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMostRecentPayOut(authorization: string, options?: RawAxiosRequestConfig) {
        return PayOutControllerApiFp(this.configuration).getMostRecentPayOut(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPayoutRequest(authorization: string, options?: RawAxiosRequestConfig) {
        return PayOutControllerApiFp(this.configuration).getPayoutRequest(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {PayOutDTO} payOutDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendPayOut(authorization: string, payOutDTO: PayOutDTO, options?: RawAxiosRequestConfig) {
        return PayOutControllerApiFp(this.configuration).sendPayOut(authorization, payOutDTO, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PieceControllerApi - axios parameter creator
 */
export const PieceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {ConfirmedMessageDto} confirmedMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirm: async (id: number, authorization: string, confirmedMessageDto: ConfirmedMessageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('confirm', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('confirm', 'authorization', authorization)
            // verify required parameter 'confirmedMessageDto' is not null or undefined
            assertParamExists('confirm', 'confirmedMessageDto', confirmedMessageDto)
            const localVarPath = `/piece/confirm/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(confirmedMessageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePiece: async (id: number, authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePiece', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deletePiece', 'authorization', authorization)
            const localVarPath = `/piece/delete/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} scoreId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPiece: async (id: number, scoreId: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadPiece', 'id', id)
            // verify required parameter 'scoreId' is not null or undefined
            assertParamExists('downloadPiece', 'scoreId', scoreId)
            const localVarPath = `/piece/{id}/download/{scoreId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"scoreId"}}`, encodeURIComponent(String(scoreId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PieceFilterDTO} pieceFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filter: async (pieceFilterDTO: PieceFilterDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pieceFilterDTO' is not null or undefined
            assertParamExists('filter', 'pieceFilterDTO', pieceFilterDTO)
            const localVarPath = `/piece/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pieceFilterDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPieces: async (authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getAllPieces', 'authorization', authorization)
            const localVarPath = `/piece/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnPiece: async (id: number, authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOwnPiece', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getOwnPiece', 'authorization', authorization)
            const localVarPath = `/piece/own/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnPieces: async (authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getOwnPieces', 'authorization', authorization)
            const localVarPath = `/piece/own`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPiece: async (id: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPiece', 'id', id)
            const localVarPath = `/piece/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPieceAdmin: async (id: number, authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPieceAdmin', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPieceAdmin', 'authorization', authorization)
            const localVarPath = `/piece/admin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPieceMin: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPieceMin', 'id', id)
            const localVarPath = `/piece/{id}/min`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPiece: async (id: number, authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('listPiece', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listPiece', 'authorization', authorization)
            const localVarPath = `/piece/list/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlistPiece: async (id: number, authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unlistPiece', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('unlistPiece', 'authorization', authorization)
            const localVarPath = `/piece/unlist/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {number} id 
         * @param {PieceDTO} pieceDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePiece: async (authorization: string, id: number, pieceDTO: PieceDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updatePiece', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePiece', 'id', id)
            // verify required parameter 'pieceDTO' is not null or undefined
            assertParamExists('updatePiece', 'pieceDTO', pieceDTO)
            const localVarPath = `/piece/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pieceDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {PieceDTO} pieceDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPiece: async (authorization: string, pieceDTO: PieceDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('uploadPiece', 'authorization', authorization)
            // verify required parameter 'pieceDTO' is not null or undefined
            assertParamExists('uploadPiece', 'pieceDTO', pieceDTO)
            const localVarPath = `/piece`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pieceDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {number} artistId 
         * @param {PieceDTO} pieceDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPiece1: async (authorization: string, artistId: number, pieceDTO: PieceDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('uploadPiece1', 'authorization', authorization)
            // verify required parameter 'artistId' is not null or undefined
            assertParamExists('uploadPiece1', 'artistId', artistId)
            // verify required parameter 'pieceDTO' is not null or undefined
            assertParamExists('uploadPiece1', 'pieceDTO', pieceDTO)
            const localVarPath = `/piece/{artistId}`
                .replace(`{${"artistId"}}`, encodeURIComponent(String(artistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pieceDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PieceControllerApi - functional programming interface
 */
export const PieceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PieceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {ConfirmedMessageDto} confirmedMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirm(id: number, authorization: string, confirmedMessageDto: ConfirmedMessageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirm(id, authorization, confirmedMessageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PieceControllerApi.confirm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePiece(id: number, authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePiece(id, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PieceControllerApi.deletePiece']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} scoreId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadPiece(id: number, scoreId: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadPiece(id, scoreId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PieceControllerApi.downloadPiece']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PieceFilterDTO} pieceFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filter(pieceFilterDTO: PieceFilterDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PieceFilterResultDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filter(pieceFilterDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PieceControllerApi.filter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPieces(authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PieceAdminResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPieces(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PieceControllerApi.getAllPieces']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOwnPiece(id: number, authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PieceResponseDTOOwn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOwnPiece(id, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PieceControllerApi.getOwnPiece']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOwnPieces(authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PieceResponseDTOMin>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOwnPieces(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PieceControllerApi.getOwnPieces']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPiece(id: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PieceResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPiece(id, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PieceControllerApi.getPiece']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPieceAdmin(id: number, authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PieceResponseDTOAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPieceAdmin(id, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PieceControllerApi.getPieceAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPieceMin(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PieceResponseDTOMin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPieceMin(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PieceControllerApi.getPieceMin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPiece(id: number, authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPiece(id, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PieceControllerApi.listPiece']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlistPiece(id: number, authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlistPiece(id, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PieceControllerApi.unlistPiece']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {number} id 
         * @param {PieceDTO} pieceDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePiece(authorization: string, id: number, pieceDTO: PieceDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PieceResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePiece(authorization, id, pieceDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PieceControllerApi.updatePiece']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {PieceDTO} pieceDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPiece(authorization: string, pieceDTO: PieceDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PieceResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPiece(authorization, pieceDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PieceControllerApi.uploadPiece']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {number} artistId 
         * @param {PieceDTO} pieceDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPiece1(authorization: string, artistId: number, pieceDTO: PieceDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PieceResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPiece1(authorization, artistId, pieceDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PieceControllerApi.uploadPiece1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PieceControllerApi - factory interface
 */
export const PieceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PieceControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {ConfirmedMessageDto} confirmedMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirm(id: number, authorization: string, confirmedMessageDto: ConfirmedMessageDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.confirm(id, authorization, confirmedMessageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePiece(id: number, authorization: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePiece(id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} scoreId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPiece(id: number, scoreId: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.downloadPiece(id, scoreId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PieceFilterDTO} pieceFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filter(pieceFilterDTO: PieceFilterDTO, options?: RawAxiosRequestConfig): AxiosPromise<PieceFilterResultDTO> {
            return localVarFp.filter(pieceFilterDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPieces(authorization: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PieceAdminResponseDTO>> {
            return localVarFp.getAllPieces(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnPiece(id: number, authorization: string, options?: RawAxiosRequestConfig): AxiosPromise<PieceResponseDTOOwn> {
            return localVarFp.getOwnPiece(id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnPieces(authorization: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PieceResponseDTOMin>> {
            return localVarFp.getOwnPieces(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPiece(id: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PieceResponseDTO> {
            return localVarFp.getPiece(id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPieceAdmin(id: number, authorization: string, options?: RawAxiosRequestConfig): AxiosPromise<PieceResponseDTOAdmin> {
            return localVarFp.getPieceAdmin(id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPieceMin(id: number, options?: RawAxiosRequestConfig): AxiosPromise<PieceResponseDTOMin> {
            return localVarFp.getPieceMin(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPiece(id: number, authorization: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.listPiece(id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlistPiece(id: number, authorization: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unlistPiece(id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {number} id 
         * @param {PieceDTO} pieceDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePiece(authorization: string, id: number, pieceDTO: PieceDTO, options?: RawAxiosRequestConfig): AxiosPromise<PieceResponseDTO> {
            return localVarFp.updatePiece(authorization, id, pieceDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {PieceDTO} pieceDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPiece(authorization: string, pieceDTO: PieceDTO, options?: RawAxiosRequestConfig): AxiosPromise<PieceResponseDTO> {
            return localVarFp.uploadPiece(authorization, pieceDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {number} artistId 
         * @param {PieceDTO} pieceDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPiece1(authorization: string, artistId: number, pieceDTO: PieceDTO, options?: RawAxiosRequestConfig): AxiosPromise<PieceResponseDTO> {
            return localVarFp.uploadPiece1(authorization, artistId, pieceDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PieceControllerApi - object-oriented interface
 */
export class PieceControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {string} authorization 
     * @param {ConfirmedMessageDto} confirmedMessageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public confirm(id: number, authorization: string, confirmedMessageDto: ConfirmedMessageDto, options?: RawAxiosRequestConfig) {
        return PieceControllerApiFp(this.configuration).confirm(id, authorization, confirmedMessageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePiece(id: number, authorization: string, options?: RawAxiosRequestConfig) {
        return PieceControllerApiFp(this.configuration).deletePiece(id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} scoreId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadPiece(id: number, scoreId: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return PieceControllerApiFp(this.configuration).downloadPiece(id, scoreId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PieceFilterDTO} pieceFilterDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public filter(pieceFilterDTO: PieceFilterDTO, options?: RawAxiosRequestConfig) {
        return PieceControllerApiFp(this.configuration).filter(pieceFilterDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllPieces(authorization: string, options?: RawAxiosRequestConfig) {
        return PieceControllerApiFp(this.configuration).getAllPieces(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOwnPiece(id: number, authorization: string, options?: RawAxiosRequestConfig) {
        return PieceControllerApiFp(this.configuration).getOwnPiece(id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOwnPieces(authorization: string, options?: RawAxiosRequestConfig) {
        return PieceControllerApiFp(this.configuration).getOwnPieces(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPiece(id: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return PieceControllerApiFp(this.configuration).getPiece(id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPieceAdmin(id: number, authorization: string, options?: RawAxiosRequestConfig) {
        return PieceControllerApiFp(this.configuration).getPieceAdmin(id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPieceMin(id: number, options?: RawAxiosRequestConfig) {
        return PieceControllerApiFp(this.configuration).getPieceMin(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listPiece(id: number, authorization: string, options?: RawAxiosRequestConfig) {
        return PieceControllerApiFp(this.configuration).listPiece(id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unlistPiece(id: number, authorization: string, options?: RawAxiosRequestConfig) {
        return PieceControllerApiFp(this.configuration).unlistPiece(id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {number} id 
     * @param {PieceDTO} pieceDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePiece(authorization: string, id: number, pieceDTO: PieceDTO, options?: RawAxiosRequestConfig) {
        return PieceControllerApiFp(this.configuration).updatePiece(authorization, id, pieceDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {PieceDTO} pieceDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadPiece(authorization: string, pieceDTO: PieceDTO, options?: RawAxiosRequestConfig) {
        return PieceControllerApiFp(this.configuration).uploadPiece(authorization, pieceDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {number} artistId 
     * @param {PieceDTO} pieceDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadPiece1(authorization: string, artistId: number, pieceDTO: PieceDTO, options?: RawAxiosRequestConfig) {
        return PieceControllerApiFp(this.configuration).uploadPiece1(authorization, artistId, pieceDTO, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PurchaseControllerApi - axios parameter creator
 */
export const PurchaseControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkCreditPurchaseCheckout: async (authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('checkCreditPurchaseCheckout', 'authorization', authorization)
            const localVarPath = `/purchase/credit/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPurchaseCheckout: async (authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('checkPurchaseCheckout', 'authorization', authorization)
            const localVarPath = `/purchase/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPurchases: async (authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getAllPurchases', 'authorization', authorization)
            const localVarPath = `/purchase/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPiecePurchaseInfo: async (authorization: string, id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPiecePurchaseInfo', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPiecePurchaseInfo', 'id', id)
            const localVarPath = `/purchase/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {PurchaseAccountCreditCommitDto} purchaseAccountCreditCommitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushAccountCreditCommit: async (authorization: string, purchaseAccountCreditCommitDto: PurchaseAccountCreditCommitDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('pushAccountCreditCommit', 'authorization', authorization)
            // verify required parameter 'purchaseAccountCreditCommitDto' is not null or undefined
            assertParamExists('pushAccountCreditCommit', 'purchaseAccountCreditCommitDto', purchaseAccountCreditCommitDto)
            const localVarPath = `/purchase/credit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(purchaseAccountCreditCommitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {number} id 
         * @param {PurchaseCommitDto} purchaseCommitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushPurchaseCommit: async (authorization: string, id: number, purchaseCommitDto: PurchaseCommitDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('pushPurchaseCommit', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pushPurchaseCommit', 'id', id)
            // verify required parameter 'purchaseCommitDto' is not null or undefined
            assertParamExists('pushPurchaseCommit', 'purchaseCommitDto', purchaseCommitDto)
            const localVarPath = `/purchase/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(purchaseCommitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PurchaseControllerApi - functional programming interface
 */
export const PurchaseControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PurchaseControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkCreditPurchaseCheckout(authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkCreditPurchaseCheckout(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseControllerApi.checkCreditPurchaseCheckout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkPurchaseCheckout(authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PieceResponseDTOMin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkPurchaseCheckout(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseControllerApi.checkPurchaseCheckout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPurchases(authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PurchaseResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPurchases(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseControllerApi.getAllPurchases']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPiecePurchaseInfo(authorization: string, id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseInfoResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPiecePurchaseInfo(authorization, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseControllerApi.getPiecePurchaseInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {PurchaseAccountCreditCommitDto} purchaseAccountCreditCommitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pushAccountCreditCommit(authorization: string, purchaseAccountCreditCommitDto: PurchaseAccountCreditCommitDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountCreditCheckoutResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pushAccountCreditCommit(authorization, purchaseAccountCreditCommitDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseControllerApi.pushAccountCreditCommit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {number} id 
         * @param {PurchaseCommitDto} purchaseCommitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pushPurchaseCommit(authorization: string, id: number, purchaseCommitDto: PurchaseCommitDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PieceCheckoutResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pushPurchaseCommit(authorization, id, purchaseCommitDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseControllerApi.pushPurchaseCommit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PurchaseControllerApi - factory interface
 */
export const PurchaseControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PurchaseControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkCreditPurchaseCheckout(authorization: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.checkCreditPurchaseCheckout(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPurchaseCheckout(authorization: string, options?: RawAxiosRequestConfig): AxiosPromise<PieceResponseDTOMin> {
            return localVarFp.checkPurchaseCheckout(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPurchases(authorization: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PurchaseResponseDTO>> {
            return localVarFp.getAllPurchases(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPiecePurchaseInfo(authorization: string, id: number, options?: RawAxiosRequestConfig): AxiosPromise<PurchaseInfoResponseDTO> {
            return localVarFp.getPiecePurchaseInfo(authorization, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {PurchaseAccountCreditCommitDto} purchaseAccountCreditCommitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushAccountCreditCommit(authorization: string, purchaseAccountCreditCommitDto: PurchaseAccountCreditCommitDto, options?: RawAxiosRequestConfig): AxiosPromise<AccountCreditCheckoutResponse> {
            return localVarFp.pushAccountCreditCommit(authorization, purchaseAccountCreditCommitDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {number} id 
         * @param {PurchaseCommitDto} purchaseCommitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushPurchaseCommit(authorization: string, id: number, purchaseCommitDto: PurchaseCommitDto, options?: RawAxiosRequestConfig): AxiosPromise<PieceCheckoutResponseDTO> {
            return localVarFp.pushPurchaseCommit(authorization, id, purchaseCommitDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PurchaseControllerApi - object-oriented interface
 */
export class PurchaseControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checkCreditPurchaseCheckout(authorization: string, options?: RawAxiosRequestConfig) {
        return PurchaseControllerApiFp(this.configuration).checkCreditPurchaseCheckout(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checkPurchaseCheckout(authorization: string, options?: RawAxiosRequestConfig) {
        return PurchaseControllerApiFp(this.configuration).checkPurchaseCheckout(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllPurchases(authorization: string, options?: RawAxiosRequestConfig) {
        return PurchaseControllerApiFp(this.configuration).getAllPurchases(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPiecePurchaseInfo(authorization: string, id: number, options?: RawAxiosRequestConfig) {
        return PurchaseControllerApiFp(this.configuration).getPiecePurchaseInfo(authorization, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {PurchaseAccountCreditCommitDto} purchaseAccountCreditCommitDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public pushAccountCreditCommit(authorization: string, purchaseAccountCreditCommitDto: PurchaseAccountCreditCommitDto, options?: RawAxiosRequestConfig) {
        return PurchaseControllerApiFp(this.configuration).pushAccountCreditCommit(authorization, purchaseAccountCreditCommitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {number} id 
     * @param {PurchaseCommitDto} purchaseCommitDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public pushPurchaseCommit(authorization: string, id: number, purchaseCommitDto: PurchaseCommitDto, options?: RawAxiosRequestConfig) {
        return PurchaseControllerApiFp(this.configuration).pushPurchaseCommit(authorization, id, purchaseCommitDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportControllerApi - axios parameter creator
 */
export const ReportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ReportDTO} reportDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportPiece: async (reportDTO: ReportDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportDTO' is not null or undefined
            assertParamExists('reportPiece', 'reportDTO', reportDTO)
            const localVarPath = `/reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportControllerApi - functional programming interface
 */
export const ReportControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ReportDTO} reportDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportPiece(reportDTO: ReportDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportPiece(reportDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportControllerApi.reportPiece']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportControllerApi - factory interface
 */
export const ReportControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {ReportDTO} reportDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportPiece(reportDTO: ReportDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reportPiece(reportDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportControllerApi - object-oriented interface
 */
export class ReportControllerApi extends BaseAPI {
    /**
     * 
     * @param {ReportDTO} reportDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportPiece(reportDTO: ReportDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return ReportControllerApiFp(this.configuration).reportPiece(reportDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ScoreControllerApi - axios parameter creator
 */
export const ScoreControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {UploadRequest} [uploadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload: async (authorization: string, uploadRequest?: UploadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('upload', 'authorization', authorization)
            const localVarPath = `/score`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {UploadPreviewRequest} [uploadPreviewRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPreview: async (authorization: string, uploadPreviewRequest?: UploadPreviewRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('uploadPreview', 'authorization', authorization)
            const localVarPath = `/score/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadPreviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScoreControllerApi - functional programming interface
 */
export const ScoreControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScoreControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {UploadRequest} [uploadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upload(authorization: string, uploadRequest?: UploadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScoreResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upload(authorization, uploadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoreControllerApi.upload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {UploadPreviewRequest} [uploadPreviewRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPreview(authorization: string, uploadPreviewRequest?: UploadPreviewRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPreview(authorization, uploadPreviewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoreControllerApi.uploadPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ScoreControllerApi - factory interface
 */
export const ScoreControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScoreControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {UploadRequest} [uploadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload(authorization: string, uploadRequest?: UploadRequest, options?: RawAxiosRequestConfig): AxiosPromise<ScoreResponseDTO> {
            return localVarFp.upload(authorization, uploadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {UploadPreviewRequest} [uploadPreviewRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPreview(authorization: string, uploadPreviewRequest?: UploadPreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetResponseDTO> {
            return localVarFp.uploadPreview(authorization, uploadPreviewRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ScoreControllerApi - object-oriented interface
 */
export class ScoreControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} authorization 
     * @param {UploadRequest} [uploadRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public upload(authorization: string, uploadRequest?: UploadRequest, options?: RawAxiosRequestConfig) {
        return ScoreControllerApiFp(this.configuration).upload(authorization, uploadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {UploadPreviewRequest} [uploadPreviewRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadPreview(authorization: string, uploadPreviewRequest?: UploadPreviewRequest, options?: RawAxiosRequestConfig) {
        return ScoreControllerApiFp(this.configuration).uploadPreview(authorization, uploadPreviewRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SettingsControllerApi - axios parameter creator
 */
export const SettingsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {UpdateEmailDto} updateEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeEmail: async (authorization: string, updateEmailDto: UpdateEmailDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('changeEmail', 'authorization', authorization)
            // verify required parameter 'updateEmailDto' is not null or undefined
            assertParamExists('changeEmail', 'updateEmailDto', updateEmailDto)
            const localVarPath = `/settings/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmailDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings: async (authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getSettings', 'authorization', authorization)
            const localVarPath = `/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {UpdatePasswordDto} updatePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword: async (authorization: string, updatePasswordDto: UpdatePasswordDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updatePassword', 'authorization', authorization)
            // verify required parameter 'updatePasswordDto' is not null or undefined
            assertParamExists('updatePassword', 'updatePasswordDto', updatePasswordDto)
            const localVarPath = `/settings/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SettingsControllerApi - functional programming interface
 */
export const SettingsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SettingsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {UpdateEmailDto} updateEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeEmail(authorization: string, updateEmailDto: UpdateEmailDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyEmailResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeEmail(authorization, updateEmailDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsControllerApi.changeEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSettings(authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SettingsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSettings(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsControllerApi.getSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {UpdatePasswordDto} updatePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePassword(authorization: string, updatePasswordDto: UpdatePasswordDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePassword(authorization, updatePasswordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsControllerApi.updatePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SettingsControllerApi - factory interface
 */
export const SettingsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SettingsControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {UpdateEmailDto} updateEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeEmail(authorization: string, updateEmailDto: UpdateEmailDto, options?: RawAxiosRequestConfig): AxiosPromise<VerifyEmailResponseDTO> {
            return localVarFp.changeEmail(authorization, updateEmailDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings(authorization: string, options?: RawAxiosRequestConfig): AxiosPromise<SettingsResponseDTO> {
            return localVarFp.getSettings(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {UpdatePasswordDto} updatePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword(authorization: string, updatePasswordDto: UpdatePasswordDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePassword(authorization, updatePasswordDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SettingsControllerApi - object-oriented interface
 */
export class SettingsControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} authorization 
     * @param {UpdateEmailDto} updateEmailDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public changeEmail(authorization: string, updateEmailDto: UpdateEmailDto, options?: RawAxiosRequestConfig) {
        return SettingsControllerApiFp(this.configuration).changeEmail(authorization, updateEmailDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSettings(authorization: string, options?: RawAxiosRequestConfig) {
        return SettingsControllerApiFp(this.configuration).getSettings(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {UpdatePasswordDto} updatePasswordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePassword(authorization: string, updatePasswordDto: UpdatePasswordDto, options?: RawAxiosRequestConfig) {
        return SettingsControllerApiFp(this.configuration).updatePassword(authorization, updatePasswordDto, options).then((request) => request(this.axios, this.basePath));
    }
}



